(window.theme = window.theme || {}),
  void 0 === window.Shopify && (window.Shopify = {}),
  (Shopify.bind = (e, t) => () => e.apply(t, arguments)),
  (Shopify.setSelectorByValue = (e, t) => {
    for (var s = 0, i = e.options.length; s < i; s++) {
      var r = e.options[s];
      if (t == r.value || t == r.innerHTML) return (e.selectedIndex = s);
    }
  }),
  (Shopify.addListener = (e, t, s) => {
    e.addEventListener ? e.addEventListener(t, s, !1) : e.attachEvent("on" + t, s);
  }),
  (Shopify.postLink = (e, t) => {
    var s,
      i = (t = t || {}).method || "post",
      r = t.parameters || {},
      a = document.createElement("form");
    for (s in (a.setAttribute("method", i), a.setAttribute("action", e), r)) {
      var n = document.createElement("input");
      n.setAttribute("type", "hidden"), n.setAttribute("name", s), n.setAttribute("value", r[s]), a.appendChild(n);
    }
    document.body.appendChild(a), a.submit(), document.body.removeChild(a);
  }),
  (Shopify.CountryProvinceSelector = function (e, t, s) {
    (this.countryEl = document.getElementById(e)),
      (this.provinceEl = document.getElementById(t)),
      (this.provinceContainer = document.getElementById(s.hideElement || t)),
      Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)),
      this.initCountry(),
      this.initProvince();
  }),
  (Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      var e = this.countryEl.getAttribute("data-default");
      Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler();
    },
    initProvince: function () {
      var e = this.provinceEl.getAttribute("data-default");
      e && 0 < this.provinceEl.options.length && Shopify.setSelectorByValue(this.provinceEl, e);
    },
    countryHandler: function (e) {
      var t = (i = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces"),
        s = JSON.parse(t);
      if ((this.clearOptions(this.provinceEl), s && 0 == s.length)) this.provinceContainer.style.display = "none";
      else {
        for (var i, r = 0; r < s.length; r++) ((i = document.createElement("option")).value = s[r][0]), (i.innerHTML = s[r][1]), this.provinceEl.appendChild(i);
        this.provinceContainer.style.display = "";
      }
    },
    clearOptions: (e) => {
      for (; e.firstChild; ) e.removeChild(e.firstChild);
    },
    setOptions: (e, t) => {
      var s = 0;
      for (t.length; s < t.length; s++) {
        var i = document.createElement("option");
        (i.value = t[s]), (i.innerHTML = t[s]), e.appendChild(i);
      }
    },
  }),
  (theme.config = {
    mediaQueries: {
      landscapeAll: "screen and (orientation: landscape)",
      landscape: "screen and (orientation: landscape), screen and (min-width: 48rem)",
      belowTablet: "screen and (max-width: 47.99rem)",
      tablet: "screen and (min-width: 48rem)",
      belowLaptop: "screen and (max-width: 63.99rem)",
      laptop: "screen and (min-width: 64rem)",
      belowDesktop: "screen and (max-width: 64rem)",
      desktop: "screen and (min-width: 64.01rem)",
      belowWidescreen: "screen and (max-width: 79.99rem)",
      widescreen: "screen and (min-width: 80rem)",
      belowExtrawide: "screen and (max-width: 89.99rem)",
      extrawide: "screen and (min-width: 90rem)",
    },
    money: {
      format: `${window.currency.symbol || "$"}{{amount}}`,
      currentCurrency: "" + (window.currency.symbol || "$"),
      currencySymbols: {
        USD: "$",
        CAD: "$",
        EUR: "€",
        CRC: "₡",
        GBP: "£",
        ILS: "₪",
        INR: "₹",
        JPY: "¥",
        KRW: "₩",
        NGN: "₦",
        PHP: "₱",
        PLN: "zł",
        PYG: "₲",
        THB: "฿",
        UAH: "₴",
        VND: "₫",
        DKK: "kr",
      },
    },
    upsellLimit: 6,
  }),
  (theme.utils = {
    subscriptions: {
      subscribers: {},
      subscribe(e, t) {
        return (
          void 0 === theme.utils.subscriptions.subscribers[e] && (theme.utils.subscriptions.subscribers[e] = []),
          (theme.utils.subscriptions.subscribers[e] = [...theme.utils.subscriptions.subscribers[e], t]),
          () => {
            theme.utils.subscriptions.subscribers[e] = theme.utils.subscriptions.subscribers[e].filter((e) => e !== t);
          }
        );
      },
      publish(e, t) {
        theme.utils.subscriptions.subscribers[e] &&
          theme.utils.subscriptions.subscribers[e].forEach((e) => {
            e(t);
          });
      },
    },
    a11y: {
      getFocusableElements(e) {
        return Array.from(
          e.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
          ),
        );
      },
      _trapFocusHandlers: {},
      trapFocus(t, e = t) {
        var s = theme.utils.a11y.getFocusableElements(t),
          i = s[0],
          r = s[s.length - 1];
        theme.utils.a11y.removeTrapFocus(),
          (theme.utils.a11y._trapFocusHandlers.focusin = (e) => {
            (e.target !== t && e.target !== r && e.target !== i) || document.addEventListener("keydown", theme.utils.a11y._trapFocusHandlers.keydown);
          }),
          (theme.utils.a11y._trapFocusHandlers.focusout = () => {
            document.removeEventListener("keydown", theme.utils.a11y._trapFocusHandlers.keydown);
          }),
          (theme.utils.a11y._trapFocusHandlers.keydown = (e) => {
            "TAB" === e.code.toUpperCase() &&
              (e.target !== r || e.shiftKey || (e.preventDefault(), i.focus()), e.target === t || e.target === i) &&
              e.shiftKey &&
              (e.preventDefault(), r.focus());
          }),
          document.addEventListener("focusout", theme.utils.a11y._trapFocusHandlers.focusout),
          document.addEventListener("focusin", theme.utils.a11y._trapFocusHandlers.focusin),
          e.focus();
      },
      removeTrapFocus(e = null) {
        document.removeEventListener("focusin", theme.utils.a11y._trapFocusHandlers.focusin),
          document.removeEventListener("focusout", theme.utils.a11y._trapFocusHandlers.focusout),
          document.removeEventListener("keydown", theme.utils.a11y._trapFocusHandlers.keydown),
          e && e.focus();
      },
    },
    prepareTransition(e) {
      e.addEventListener("transitionend", () => {
        e.classList.remove("is-transitioning");
      });
      let t = 0,
        s = getComputedStyle(e);
      ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"].forEach(
        (e) => (t = t || parseFloat(s.getPropertyValue(e))),
      ),
        0 != t && (e.classList.add("is-transitioning"), e.offsetWidth);
    },
    defaultTo: (e, t) => (null == e || e != e ? t : e),
    formatMoney(e, t) {
      "string" == typeof e && (e = e.replace(".", ""));
      var s = "",
        o = /\{\{\s*(\w+)\s*\}\}/;
      let c;
      function i(e, t, s, i) {
        if (((t = theme.utils.defaultTo(t, 2)), (s = theme.utils.defaultTo(s, ",")), (i = theme.utils.defaultTo(i, ".")), isNaN(e) || null == e)) return 0;
        let r = (e = (e / 100).toFixed(t)).split("."),
          a = r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + s),
          n = r[1] ? i + r[1] : "";
        return a + (n = "no_trailing_zeros" == c.match(o)[1] && ".00" == n ? "" : n);
      }
      switch ((c = t || ("kr." === theme.config.money.currentCurrency ? "{{ amount_danish }}" : theme.config.money.format)).match(o)[1]) {
        case "amount":
          s = i(e, 2);
          break;
        case "amount_no_decimals":
          s = i(e, 0);
          break;
        case "amount_with_space_separator":
          s = i(e, 2, " ", ".");
          break;
        case "amount_no_decimals_with_comma_separator":
          s = i(e, 0, ",", ".");
          break;
        case "amount_no_decimals_with_space_separator":
          s = i(e, 0, " ");
          break;
        case "no_trailing_zeros":
          s = i(e, 2);
          break;
        case "amount_danish":
          s = i(e, 2, ".", ",") + " kr";
      }
      return c.replace(o, s);
    },
    serializeForm: (e) => {
      var t,
        s = {},
        i = new FormData(e);
      for (t of i.keys()) {
        var r = /(?:^(properties\[))(.*?)(?:\]$)/;
        r.test(t) ? ((s.properties = s.properties || {}), (s.properties[r.exec(t)[2]] = i.get(t))) : (s[t] = i.get(t));
      }
      return JSON.stringify(s);
    },
    debounce(t, s) {
      let i;
      return (...e) => {
        clearTimeout(i), (i = setTimeout(() => t.apply(this, e), s));
      };
    },
    getSiblings(e, t) {
      var s,
        i = [];
      let r;
      for (s of (r = t ? e.parentNode.querySelectorAll(":scope > " + t) : e.parentNode.children)) s !== e && i.push(s);
      return i;
    },
    refreshElements(e, t, s) {
      e.forEach((e) => {
        const a = t.querySelectorAll(e);
        s.querySelectorAll(e).forEach((e, t) => {
          var s, i, r;
          a[t]
            ? null != e.getAttribute("js-accordion-item")
              ? ((s = e.querySelector("[js-accordion-header]").getAttribute("aria-expanded")),
                (i = e.querySelector("[js-accordion-content]").getAttribute("aria-hidden")),
                (r = a[t]).querySelector("[js-accordion-header]").setAttribute("aria-expanded", s),
                r.querySelector("[js-accordion-content]").setAttribute("aria-hidden", i),
                (e.innerHTML = r.innerHTML))
              : (e.innerHTML = a[t].innerHTML)
            : e.remove();
        });
      });
    },
    extractWeightAndUnit(e) {
      e = e.match(/(\d+(?:\.\d+)?)\s*([a-zA-Z]+)/);
      return e ? { weight: parseFloat(e[1]), unit: e[2].toLowerCase() } : { weight: 0, unit: "" };
    },
    handleize(e) {
      return e
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/-$/, "")
        .replace(/^-/, "");
    },
    getCookie(e) {
      for (var t = e + "=", s = decodeURIComponent(document.cookie).split(";"), i = 0; i < s.length; i++) {
        for (var r = s[i]; " " == r.charAt(0); ) r = r.substring(1);
        if (0 == r.indexOf(t)) return r.substring(t.length, r.length);
      }
      return "";
    },
    setCookie(e, t, s) {
      var i = new Date(),
        s = (i.setTime(i.getTime() + 24 * s * 60 * 60 * 1e3), "expires=" + i.toUTCString());
      document.cookie = e + "=" + t + ";" + s + "domain=.vuffeli.dk;path=/";
    },
  });
class FocusableWidget extends HTMLElement {
  constructor(e = {}) {
    if ((super(), !e.name)) throw new Error(`Focusable Widget(${e.name}) must have a name`);
    if (!this.id) throw new Error(e.name + " must have an id");
    if (!e.background) throw new Error(`Focusable Widget(${e.name}) must have a background`);
    (this._clientConfig = e), this._init(e);
  }
  open = () => {
    if (!this._isOpen) return this._closeFocusableWidgets(), this.toggle();
  };
  close = () => {
    if (this._isOpen) return this.toggle();
  };
  toggle = () => (
    theme.utils.prepareTransition(this),
    this._toggleClasses(),
    this._toggleAccessibilityAttributes(),
    this._isOpen
      ? (theme.utils.a11y.removeTrapFocus(this), this._unbindEvents(), this._dispatchEvents(this._events.close, ["close"]))
      : (theme.utils.a11y.trapFocus(this), this._bindEvents(), this._dispatchEvents(this._events.open, ["open"])),
    (this._isOpen = !this._isOpen),
    this
  );
  reinitWidget = () => {
    this._init(this._clientConfig);
  };
  get isOpen() {
    return this._isOpen;
  }
  _init({ name: e, background: t, widgetOpenClasses: s = [], bodyOpenClasses: i = [], attributes: r = {} }) {
    (this._name = e),
      (this._isOpen = !1),
      (this._selectors = { background: t, open: this.getAttribute("open"), close: this.getAttribute("close") }),
      (this._nodes = { background: document.querySelector(this._selectors.background) }),
      (this._events = { open: ["focusable-widget:open", e + ":open", this.id + ":open"], close: ["focusable-widget:close", e + ":close", this.id + ":close"] }),
      (this._config = {
        open: document.querySelectorAll(this._selectors.open),
        close: document.querySelectorAll(this._selectors.close),
        attributes: { "data-focusable-widget": "true", "aria-hidden": "true", tabindex: 0, ...r },
        widgetOpenClasses: ["open", this.getAttribute("open-class")].concat(s),
        bodyOpenClasses: ["js-focusable-widget-open", `js-${e}-open`, this.getAttribute("body-open-class")].concat(i),
      }),
      this._validateConfig(),
      this._addAccessibilityAttributes(),
      this._setupListeners();
  }
  _validateConfig() {
    if (
      ((this._config.open && this._config.open.length) ||
        console.warn(`WARN: ${this._name}: no open triggers found. Check your ${this._name} 'open' attribute, or add a trigger (if needed)`),
      !this._config.close || !this._config.close.length)
    )
      throw new Error(`${this._name}: invalid close trigger selector, no elements found. Check your ${this._name} 'close' attribute`);
  }
  _setupListeners() {
    this._config.open.forEach((e) => e.addEventListener("click", this._open.bind(this))),
      this._config.close.forEach((e) => e.addEventListener("click", this._close.bind(this))),
      this.addEventListener("click", (e) => e.stopPropagation());
  }
  _open(e) {
    e && (e.preventDefault(), e.stopPropagation()), this.open();
  }
  _close = (e) => {
    e && (e.preventDefault(), e.stopPropagation()), this.close();
  };
  _closeFocusableWidgets() {
    document.querySelectorAll("[data-focusable-widget].open").forEach((e) => e.close());
  }
  _dispatchEvents(e, t) {
    e.forEach((e) => document.dispatchEvent(new CustomEvent(e))), t && t.length && t.forEach((e) => this.dispatchEvent(new CustomEvent(e)));
  }
  _bindEvents() {
    document.addEventListener("keyup", this._onKeyUp),
      this._nodes.background.addEventListener("click", this._close),
      this._nodes.background.addEventListener("touchmove", this._onTouchMove);
  }
  _unbindEvents() {
    document.removeEventListener("keyup", this._onKeyUp),
      this._nodes.background.removeEventListener("click", this._close),
      this._nodes.background.removeEventListener("touchmove", this._onTouchMove);
  }
  _toggleClasses() {
    this._isOpen
      ? (this._config.bodyOpenClasses.forEach((e) => {
          e && document.body.classList.remove(e);
        }),
        this._config.widgetOpenClasses.forEach((e) => {
          e && this.classList.remove(e);
        }))
      : (this._config.bodyOpenClasses.forEach((e) => {
          e && document.body.classList.add(e);
        }),
        this._config.widgetOpenClasses.forEach((e) => {
          e && this.classList.add(e);
        }));
  }
  _toggleAccessibilityAttributes() {
    this._isOpen
      ? (this.setAttribute("aria-hidden", "true"),
        this.setAttribute("tabindex", "-1"),
        this._config.open.forEach((e) => e.setAttribute("aria-expanded", "false")),
        this._config.close.forEach((e) => e.setAttribute("aria-expanded", "false")))
      : (this.setAttribute("aria-hidden", "false"),
        this.setAttribute("tabindex", "0"),
        this._config.open.forEach((e) => e.setAttribute("aria-expanded", "true")),
        this._config.close.forEach((e) => e.setAttribute("aria-expanded", "true")));
  }
  _addAccessibilityAttributes() {
    var e,
      t = (e) => {
        e.setAttribute("tabindex", "0"), e.setAttribute("aria-expanded", "false"), e.setAttribute("aria-controls", this.id);
      };
    for (e in this._config.attributes) this.setAttribute(e, this._config.attributes[e]);
    this._config.open.forEach(t), this._config.close.forEach(t);
  }
  _onKeyUp = (e) => {
    "ESCAPE" === e.code.toUpperCase() && this.close();
  };
  _onTouchMove = () => !1;
}
class CartApi {
  constructor() {
    (this._selectors = { cartCount: "#cart-count", openCart: "[js-open-cart]" }),
      (this.cartCountEl = document.querySelector(this._selectors.cartCount)),
      (this.cartCount = 0),
      (this.openCart = document.querySelector(this._selectors.openCart)),
      this._init();
  }
  _init() {
    window?.Rebuy && window?.Rebuy?.SmartCart ? this._onCartReady() : document.addEventListener("rebuy:smartcart.ready", this._onCartReady.bind(this));
  }
  _onCartReady() {
    (this.smartCart = window.Rebuy.SmartCart),
      (this.rebuyCart = window.Rebuy.Cart),
      (this.smartCart.skip_open = !0),
      (this.openCart.disabled = !1),
      this.openCart.addEventListener("click", () => {
        this.smartCart.show();
      }),
      (this.cartCount = this.smartCart.itemCount()),
      document.addEventListener("rebuy:cart.change", this._onCartChange.bind(this)),
      this._onCartChange();
  }
  async getItems() {
    try {
      return (await (await fetch("/cart.js", { method: "GET", headers: { "Content-Type": "application/json" } })).json()).items;
    } catch (e) {
      return console.error("Error fetching cart:", e), [];
    }
  }
  async removeItem(e) {
    try {
      await fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ updates: e }) });
    } catch (e) {
      console.error("Error removing items:", e);
    }
  }
  async _onCartChange(e) {
    this._handleFreeItemRemoval(), this._handleKitDiscount(), this._handleKitDiscountV2();
    var t = this.smartCart.itemCount();
    t !== this.cartCount && this._updateCartCount(t), this._updateItemObj(e);
  }
  async _updateItemObj(e) {
    e ? (window.seed = { cartItems: e?.detail?.cart?.cart?.items || [] }) : ((e = await this.getItems()), (window.seed = { cartItems: e }));
  }
  _updateCartCount(e) {
    (this.cartCount = e), (this.cartCountEl.innerHTML = e);
  }
  async _handleKitDiscount() {
    var e = "STARTKIT";
    var t = this.rebuyCart.items(),
      s = t.filter((e) => "Tørfoder" === e.product_type),
      t = t.filter((e) => "Starter Kit" === e.product_type),
      s = 0 < s.length,
      i = !!this.rebuyCart.getDiscount(e),
      r =
        (1 < t.length &&
          t.slice(1).forEach((e) => {
            this.removeItem({ [e.id]: 0 });
          }),
        0 < t.length);
    r && !s
      ? (this.removeItem({ [t?.[0].id]: 0 }), this.smartCart.removeDiscount(e))
      : r && s && !i
        ? this.smartCart.applyDiscount(e)
        : i && !r && this.smartCart.removeDiscount(e);
  }
  async _handleKitDiscountV2() {
    var e = "STARTKIT3";
    var t = this.rebuyCart.items(),
      s = t.filter((e) => "Tørfoder" === e.product_type),
      t = t.filter((e) => "Starter Kit V2" === e.product_type),
      s = 0 < s.length,
      i = !!this.rebuyCart.getDiscount(e),
      r =
        (1 < t.length &&
          t.slice(1).forEach((e) => {
            this.removeItem({ [e.id]: 0 });
          }),
        0 < t.length);
    r && !s
      ? (this.removeItem({ [t?.[0].id]: 0 }), this.smartCart.removeDiscount(e))
      : r && s && !i
        ? this.smartCart.applyDiscount(e)
        : i && !r && this.smartCart.removeDiscount(e);
  }
  async _handleFreeItemRemoval() {
    var e = this.smartCart.items(),
      t = e.reduce((e, t) => e + t.final_price, 0),
      s = [49019415331143];
    if (0 === t && 0 !== e.length) for (var i of e) s.includes(i.id) && this.removeItem({ [i.id]: 0 });
  }
}
window.CartApi = new CartApi();
class Drawer extends FocusableWidget {
  constructor() {
    super({ name: "drawer", background: ".drawer-background" });
    var e = this.getAttribute("position");
    if (!e) throw new Error("drawer must have position attribute");
    (this._position = e), this._config.bodyOpenClasses.push(`js-drawer-${e}-open`), (this._clientConfig.bodyOpenClasses = [`js-drawer-${e}-open`]);
  }
  get position() {
    return this._position;
  }
}
class Modal extends FocusableWidget {
  constructor() {
    super({ name: "modal", background: ".modal-background", bodyOpenClasses: "js-modal-open" });
  }
}
class Accordion extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        accordion: "[js-accordion]",
        accordionItem: "[js-accordion-item]",
        accordionHeader: "[js-accordion-header]",
        accordionContent: "[js-accordion-content]",
      });
  }
  connectedCallback() {
    (this.buttons = this.querySelectorAll(this._selectors.accordionHeader)),
      this.buttons.forEach((e) => {
        e.addEventListener("click", this._toggleContent);
      }),
      (this.content = this.querySelectorAll(this._selectors.accordionContent));
  }
  _toggleContent = (e) => {
    e.stopImmediatePropagation();
    var e = e.currentTarget,
      t = this.querySelector("#" + e.getAttribute("aria-controls")),
      s = theme.utils.getSiblings(e.parentElement, this._selectors.accordionItem);
    "false" == e.getAttribute("aria-expanded")
      ? (e.setAttribute("aria-expanded", !0),
        theme.utils.prepareTransition(t),
        this._expandSection(t),
        (this.dataset.manualCollapse && "false" != this.dataset.manualCollapse) ||
          s.forEach((e) => {
            var t = e.querySelector(this._selectors.accordionHeader),
              e = e.querySelector("#" + t.getAttribute("aria-controls"));
            "true" == t.getAttribute("aria-expanded") && (t.setAttribute("aria-expanded", !1), this._collapseSection(e));
          }))
      : (e.setAttribute("aria-expanded", !1), this._collapseSection(t));
  };
  _collapseSection(e) {
    e.setAttribute("aria-hidden", !0);
  }
  _expandSection(e) {
    e.setAttribute("aria-hidden", !1);
  }
}
class Tabs extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this._elements = {
      tabs: this.querySelectorAll("[js-tab]"),
      tabList: this.querySelectorAll("[js-tab-list]"),
      tabPanel: this.querySelectorAll("[js-tab-panel]"),
    }),
      this._tabEventListener(),
      this._tabListListener();
  }
  _resetTabAttributes() {
    var e = this._elements.tabs;
    e.forEach((e) => {
      e.removeAttribute("aria-selected"), e.removeAttribute("aria-controls");
    }),
      this.querySelectorAll("[role=tabpanel]").forEach((e) => {
        e.removeAttribute("aria-hidden");
      });
  }
  _restoreTabAttributes() {
    var e = this._elements.tabs;
    e.forEach((e, t) => {
      e.setAttribute("aria-selected", 0 === t ? "true" : "false"), e.setAttribute("aria-controls", "tabpanel-" + t);
    }),
      document.querySelectorAll("[role=tabpanel]").forEach((e, t) => {
        e.setAttribute("aria-hidden", 0 === t ? "false" : "true"), (e.id = "tabpanel-" + t);
      });
  }
  _tabEventListener = () => {
    var e = this._elements["tabs"];
    e.forEach((e) => e.addEventListener("click", this._showTabPanel));
  };
  _showTabPanel = (e) => {
    var e = e.target?.getAttribute("js-tab") ? e.target : e.target.closest("[js-tab]"),
      t = this._elements["tabs"],
      t = (t.forEach((e) => e.setAttribute("aria-selected", "false")), e.setAttribute("aria-selected", "true"), e.getAttribute("aria-controls"));
    document.querySelectorAll("[role=tabpanel]").forEach((e) => e.setAttribute("aria-hidden", "true")),
      document.getElementById(t).setAttribute("aria-hidden", "false");
  };
  _tabListListener = () => {
    var e = this._elements["tabList"];
    e.forEach((e) => e.addEventListener("keydown", this._tabListKeydown));
  };
  _tabListKeydown = (e) => {
    37 == e.keyCode && ($("[aria-selected=true]").prev().click().focus(), e.preventDefault()),
      38 == e.keyCode && ($("[aria-selected=true]").prev().click().focus(), e.preventDefault()),
      39 == e.keyCode && ($("[aria-selected=true]").next().click().focus(), e.preventDefault()),
      40 == e.keyCode && ($("[aria-selected=true]").next().click().focus(), e.preventDefault());
  };
}
class Carousel extends HTMLElement {
  constructor() {
    super(),
      (this.selectors = { carousel: "[js-carousel]" }),
      (this.options = { loop: !0, slidesPerView: "auto", grabCursor: !0, centeredSlides: !1, navigation: !1, pagination: !1 });
  }
  connectedCallback() {
    let optionsToAssign = {};
    if (this.dataset.options) {
      try {
        const cleanJson = this.dataset.options.replace(/\s+/g, " ").trim();
        console.log({ cleanJson });
        optionsToAssign = JSON.parse(cleanJson);
        console.log({ optionsToAssign });
      } catch (error) {
        console.error("Failed to parse carousel options:", JSON.stringify(this.dataset));
      }
    }
    (this.options = Object.assign(this.options, optionsToAssign)), this._initCarousel();
  }
  _initCarousel() {
    const e = "#" + this.querySelector(this.selectors.carousel).id;
    void 0 !== this.dataset.init
      ? enquire.register(theme.config.mediaQueries[this.dataset.init], {
          match: function () {
            this.carousel = new Swiper(e, this.options);
          }.bind(this),
          unmatch: function () {
            this.carousel.el.classList.contains("swiper-initialized") && this.carousel.destroy(!0, !0);
          }.bind(this),
        })
      : (this.carousel = new Swiper(e, this.options));
  }
}
class SiteHeader extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        header: "#shopify-section-header",
        drawer: "#NavDrawer",
        openNav: "[js-open-main-nav]",
        closeNav: "[js-close-main-nav]",
        announcementBar: "[js-announcement-bar]",
        search: {
          trigger: "[js-search-trigger]",
          close: "[js-search-close]",
          count: "[js-search-result-count]",
          input: 'input[type="search"]',
          results: "[js-predictive-search]",
          drawer: "predictive-search",
        },
      });
  }
  connectedCallback() {
    (this.header = document.querySelector(this._selectors.header)),
      (this.drawer = document.querySelector(this._selectors.drawer)),
      (this.closeNav = this.querySelector(this._selectors.closeNav)),
      (this.openNav = this.querySelector(this._selectors.openNav)),
      (this.search = document.querySelector(this._selectors.search.drawer)),
      (this.searchTrigger = this.querySelector(this._selectors.search.trigger)),
      (this.searchClose = this.search.querySelector(this._selectors.search.close)),
      (this.searchInput = this.search.querySelector(this._selectors.search.input)),
      (this.announcementBar = document.querySelector(this._selectors.announcementBar)),
      this._handleSearchDropdown(),
      this._setVariables(),
      this._watchWindowResize(),
      this._initAnnouncementBar(),
      document.addEventListener("NavDrawer:close", () => {
        this.openNav.focus();
      });
  }
  _initAnnouncementBar() {
    this.announcementBar.style.opacity = 100;
  }
  _handleSearchDropdown() {
    this.searchTrigger.addEventListener("click", this._toggleSearch.bind(this)),
      this.searchClose.addEventListener("click", (e) => {
        e.preventDefault(), this._toggleSearch();
      });
  }
  _toggleSearch() {
    var e = !this.search.classList.contains("hidden");
    this.search.classList.toggle("hidden"),
      document.body.classList.toggle("js-drawer-open"),
      (e ? (this.search.close(), this.searchTrigger) : this.searchInput).focus();
  }
  _watchWindowResize = (e) => {
    window.addEventListener("resize", this._setVariables);
  };
  _setVariables = (e) => {
    document.documentElement.style.setProperty("--header-height", this.header.clientHeight + "px"),
      document.documentElement.style.setProperty("--navigation-height", this.header.querySelector(".header").clientHeight + "px"),
      document.documentElement.style.setProperty("--announcement-bar-height", this.announcementBar.clientHeight + "px");
  };
}
class MegaMenu extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        mainPage: "[js-mega-menu-main]",
        childPage: "[js-mega-menu-page]",
        openBtn: "[js-mega-open-child]",
        returnBtn: "[js-mega-menu-return]",
        drawer: "s-drawer#NavDrawer",
      }),
      (this.mainPage = this.querySelector(this._selectors.mainPage)),
      (this.childPages = [...this.querySelectorAll(this._selectors.childPage)]),
      (this.openButtons = this.querySelectorAll(this._selectors.openBtn)),
      (this.returnButtons = this.querySelectorAll(this._selectors.returnBtn)),
      (this.drawer = document.querySelector(this._selectors.drawer)),
      (this._openMainPage = this._openMainPage.bind(this));
  }
  connectedCallback() {
    this._initEventListeners();
  }
  _initEventListeners() {
    this.openButtons.forEach((s) =>
      s.addEventListener("click", (e) => {
        var t = s.getAttribute("data-mega-menu-parent");
        this._openPage(t);
      }),
    );
    this.returnButtons.forEach((e) => e.addEventListener("click", this._openMainPage)),
      document.addEventListener("NavDrawer:close", () => {
        window.innerWidth < 1024 && this._handleHeaderStyling(!1), this._openMainPage(!1);
      }),
      document.addEventListener("NavDrawer:open", () => {
        window.innerWidth < 1024 && this._handleHeaderStyling(!0);
      });
  }
  _openPage(t) {
    var e = this.childPages.find((e) => e.getAttribute("data-mega-menu-parent") === t);
    e &&
      (e.classList.remove("hidden"),
      e.setAttribute("aria-hidden", "false"),
      this.mainPage.classList.add("hidden"),
      this.mainPage.setAttribute("aria-hidden", "true"),
      theme.utils.a11y.trapFocus(e),
      (e = e.querySelector(this._selectors.returnBtn))) &&
      e.focus();
  }
  _openMainPage(e = !0) {
    this.childPages.forEach((e) => {
      e.classList.add("hidden"), e.setAttribute("aria-hidden", "true");
    }),
      this.mainPage.classList.remove("hidden"),
      this.mainPage.setAttribute("aria-hidden", "false"),
      e &&
        (theme.utils.a11y.trapFocus(this.drawer), (e = this.mainPage.querySelector('[aria-expanded="true"]'))) &&
        (e.focus(), e.setAttribute("aria-expanded", "false"));
  }
  _handleHeaderStyling(e = !1) {
    var t = document.querySelector("s-header"),
      s = t.getAttribute("data-color-scheme"),
      i = "#374151";
    s != i && (e ? t.style.setProperty("--header-color-scheme", i) : t.style.setProperty("--header-color-scheme", s));
  }
}
class ProductOptions extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = { singleOptionSelector: "[js-product-option-selector]" }),
      (this._events = { change: "variant:change", fetchBefore: "variant:fetch:before", fetchAfter: "variant:fetch:after", fetchError: "variant:fetch:error" });
  }
  connectedCallback() {
    var e, h;
    (this._handle = this.dataset.productHandle),
      (this._masterSelect = document.getElementById(this.dataset.masterSelectId)),
      (this._checkAvailableOptions = !this.hasAttribute("data-disable-option-binding")),
      (this._optionSelectors = [...this.querySelectorAll(this._selectors.singleOptionSelector)]),
      this._checkAvailableOptions && ((this._availableValues = {}), (this._lastSelectedOption = null), (this._option1Values = this._option2Values = null)),
      this.dataset.product && (e = document.getElementById(this.dataset.product)) && (this._product = JSON.parse(e.innerHTML)),
      (h = document.getElementById("ProductHandleizedVariants")) && (this._handleizedVariants = JSON.parse(h.innerHTML)),
      this._product && this._handleizedVariants && (this._product.handleized_variants = this._handleizedVariants),
      this._product && ((this._currentVariant = this._getVariantFromOptions()), this._checkAvailableOptions) && this._setupOptionsAvailability(this._product),
      (this._product || this._handle) && this._setupListeners();
  }
  set product(e) {
    (this._product = e), this.disconnectedCallback(), this.connectedCallback();
  }
  _setupListeners() {
    this._optionSelectors.forEach((e) => e.addEventListener("change", this._handleOptionChange));
  }
  _getVariantFromOptions() {
    if (this._product) {
      const selectedOptions = this._getCurrentOptions();
      const variants = this._product["variants"];
      const handleizedVariants = this._product["handleized_variants"];

      return variants.find((variant, index) => {
        const handleizedVariant = handleizedVariants[index];
        return selectedOptions.every((opt) => {
          const handleKey = `${opt.index}_handle`;
          return opt.value === handleizedVariant[handleKey];
        });
      });
    }
  }
  _getCurrentOptions() {
    return this._optionSelectors
      .map((e) => {
        var t = e.getAttribute("type"),
          s = {};
        return (("radio" !== t && "checkbox" !== t) || !!e.checked) && ((s.value = e.value), (s.index = e.dataset.index), s);
      })
      .filter((e) => e);
  }
  _setupOptionsAvailability(e) {
    (this._option1Values = new Set()),
      (this._option2Values = new Set()),
      e.variants.forEach((e) => {
        var { option1: e, option2: t } = e;
        e &&
          this._option1Values.add(
            e
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, "-")
              .replace(/-$/, "")
              .replace(/^-/, ""),
          ),
          t &&
            this._option2Values.add(
              t
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, "-")
                .replace(/-$/, "")
                .replace(/^-/, ""),
            );
      }),
      (this._option1Values = [...this._option1Values]),
      (this._option2Values = [...this._option2Values]),
      this._optionSelectors.forEach((e) => {
        null == this._lastSelectedOption && e.checked && (this._lastSelectedOption = { key: e.dataset.index, value: e.value });
      }),
      (this._availableValues = this._getAvailableValues(this._product, this._lastSelectedOption)),
      this._refreshValuesUI(this._availableValues);
  }
  _handleOptionChange = (t) => {
    this._product
      ? this._updateVariant(t)
      : this._fetchProduct(this._handle)
          .then((e) => {
            (this._product = e), this._checkAvailableOptions && this._setupOptionsAvailability(this._product), this._updateVariant(t);
          })
          .catch((e) => console.log(e));
  };
  _updateVariant(e) {
    this._lastSelectedOption = { key: e.target.dataset.index, value: e.target.value };
    var t,
      s,
      e = this._getVariantFromOptions();
    this.dispatchEvent(new CustomEvent(this._events.change, { detail: { variant: e, priceChange: this._hasPriceChanged(e) }, bubbles: !0 })),
      this._checkAvailableOptions &&
        ((t = this._getAvailableValues(this._product, this._lastSelectedOption)),
        (s = this._getDifference(this._availableValues, t)),
        this._refreshValuesUI(s),
        (this._availableValues = t)),
      this.hasAttribute("data-enable-history-state") && this._updateHistoryState(e),
      this._masterSelect && this._updateMasterSelect(e),
      (this._currentVariant = e);
  }
  _hasPriceChanged(e) {
    return !(!e || !this._currentVariant || (e.price === this._currentVariant.price && e.compare_at_price === this._currentVariant.compare_at_price));
  }
  _getAvailableValues(r, a) {
    if (a) {
      const s = {};
      var e = ["option1", "option2"],
        t = { option1: this._option1Values, option2: this._option2Values };
      const i = e.find((e) => e !== a.key);
      return (
        t[i].forEach((t) => {
          var e = r.variants.findIndex(
            (e) =>
              e[a.key]
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, "-")
                .replace(/-$/, "")
                .replace(/^-/, "") === a.value &&
              e[i]
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, "-")
                .replace(/-$/, "")
                .replace(/^-/, "") === t &&
              e.available,
          );
          s[t] = 0 <= e;
        }),
        s
      );
    }
    return r.variants.reduce((e, t) => {
      var { option1: t, option2: s } = t;
      return t && (e[t] = !0), s && (e[s] = !0), e;
    }, {});
  }
  _refreshValuesUI(e) {
    for (var t in e) {
      var s = this.querySelector(`[value="${t}"]`);
      s && (s.disabled = !e[t]);
    }
  }
  _updateHistoryState(e) {
    history.replaceState &&
      e &&
      ((e = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e.id),
      window.history.replaceState({ path: e }, "", e));
  }
  _updateMasterSelect(e) {
    e && (this._masterSelect.value = e.id);
  }
  async _fetchProduct(e) {
    this.dispatchEvent(new CustomEvent(this._events.fetchBefore, { bubbles: !0 }));
    try {
      var t = await (await fetch(`/products/${e}.js`)).json();
      return this.dispatchEvent(new CustomEvent(this._events.fetchAfter, { bubbles: !0 })), t;
    } catch (e) {
      this.dispatchEvent(new CustomEvent(this._events.fetchError, { details: { error: e }, bubbles: !0 }));
    }
  }
  _getDifference(e, t) {
    var s = {};
    if (e || t) {
      if (!e) return t;
      if (!t) return e;
      for (var i in t) t[i] !== e[i] && (s[i] = t[i]);
    }
    return s;
  }
  disconnectedCallback() {
    this._optionSelectors.forEach((e) => e.removeEventListener("change", this._handleOptionChange));
  }
}
class ProductStarterKit extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = { images: ".kit-details__media img", select: "[js-kit-select]", form: "[js-product-form]" }),
      (this.select = this.querySelector(this._selectors.select)),
      (this.form = document.querySelector(this._selectors.form)),
      (this.price = Number(this.getAttribute("data-price")) ?? 0),
      (this.comparePrice = Number(this.getAttribute("data-compare-price")) ?? 0);
  }
  connectedCallback() {
    document.addEventListener("startkit:select", this.handleKitSelection),
      this.select.addEventListener("change", (e) => {
        e = e.target.value;
        this.handleKitSelection(!1, e);
      }),
      "none" !== this.select.value && this.handleKitSelection(!1, this.select.value);
  }
  getTargetOption(t) {
    return (Array.from(this.select.options).find((e) => e.dataset.type?.toLowerCase() === t?.toLowerCase()) || !1)?.value ?? !1;
  }
  getPriceData() {
    var e = this.select.value;
    return { priceChanged: "none" !== e, ...("none" !== e && { amount: this.price, amountCompare: this.comparePrice }) };
  }
  handleKitSelection(e, t = !1) {
    (e = t || this.getTargetOption(e?.detail?.selectedType)),
      t || (this.select.value = e),
      "none" === e ? this.form.removeAttribute("data-starter-kit") : this.form.setAttribute("data-starter-kit", e),
      (t = this.getPriceData());
    this.dispatchEvent(new CustomEvent("startkit:change", { detail: t, bubbles: !0 }));
  }
}

class ProductCard extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        form: "form",
        button: 'button[type="submit"]',
        buttonLabel: "[js-cart-button-label]",
        loader: "loading-spinner",
        selectVariant: "[js-card-variant-select]",
      }),
      (this.buttonState = { AVAILABLE: "AVAILABLE", UNAVAILABLE: "UNAVAILABLE", SELECT_VARIANT: "SELECT_VARIANT", ADDED: "ADDED" }),
      (this.form = this.querySelector(this._selectors.form)),
      (this.button = this.querySelector(this._selectors.button)),
      (this.buttonLabel = this.querySelector(this._selectors.buttonLabel)),
      (this.buttonSuccessIcon = this.button?.querySelector("i.success-icon")),
      (this.cart = document.querySelector("cart-drawer")),
      (this.selectVariant = this.querySelector(this._selectors.selectVariant)),
      (this.isSubscription = "true" === this.getAttribute("data-is-subscription")),
      (this.isBundle = "true" === this.getAttribute("data-is-bundle")),
      (this.isRegularProduct = !this.isBundle && !this.isSubscription),
      (this.upsellModal = document.querySelector("product-upsell")),
      (this.allowCustomLabel = "true" === this.getAttribute("data-allow-custom-label")),
      (this.variantLabel = this.getAttribute("data-variant-label")),
      (this.productHandle = this.getAttribute("data-product-handle"));
    var e,
      t = this.querySelector("#VariantJSON")?.innerHTML;
    t && (({ defaultPrices: t, variants: e } = JSON.parse(t)), (this.variantData = e), (this.defaultPrices = t));
  }
  connectedCallback() {
    if (!this.form) {
      console.error("ProductCard: Form not found");
      return;
    }
    this._boundHandleSubmit = this._handleFormSubmit.bind(this);
    this.form.addEventListener("submit", this._boundHandleSubmit, { capture: true });
    if (this.selectVariant) {
      this.selectVariant.addEventListener("change", this._handleVariantChange.bind(this));
      this._initializeSelectedVariant();
    }
    this._isInitialized = true;
  }
  disconnectedCallback() {
    if (this.form && this._boundHandleSubmit) {
      this.form.removeEventListener("submit", this._boundHandleSubmit, { capture: true });
    }
  }
  _initializeSelectedVariant() {
    const selectedValue = this.selectVariant.value;
    if (selectedValue && selectedValue !== "placeholder") {
      const changeEvent = new Event("change", { bubbles: true });
      this.selectVariant.dispatchEvent(changeEvent);
    }
  }
  _handleVariantChange(e) {
    const t = e.target.value;
    var s,
      e = "true" === e.target.options[e.target.selectedIndex].getAttribute("data-available");
    "placeholder" == t
      ? (this._handleButtonState(this.buttonState.SELECT_VARIANT),
        (s = { oneTime: { price: this.defaultPrices.priceMin, compare: this.defaultPrices.priceMinCompare } }),
        this.isRegularProduct || (s.subscription = { price: this.defaultPrices.subscriptionMin, compare: this.defaultPrices.subscriptionCompareMin }),
        this._updatePrice(s, !1),
        this._updateDiscount(!1))
      : ((s = e ? this.buttonState.AVAILABLE : this.buttonState.UNAVAILABLE),
        this._handleButtonState(s),
        (this.selectedVariant = this.variantData.find((e) => e.id == t)),
        (e = { oneTime: { price: this.selectedVariant.price, compare: this.selectedVariant.compare_at_price } }),
        (s = this.selectedVariant?.selling_plan_allocations[0]) && (e.subscription = { price: s.price, compare: s.compare_at_price }),
        this._updatePrice(e, !0),
        this.isRegularProduct || ((s = this._getDiscountPercentage(this.variantData[0], this.selectedVariant)), this._updateDiscount(s ?? !1)));
  }
  _handleFormSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    const t = new FormData(this.form);
    if ("placeholder" == t.get("id")) {
      this._handleButtonState(this.buttonState.SELECT_VARIANT);
      this.selectVariant && this._highlightSelectError();
      return;
    }
    // The upsell modal rewrites a single cart line (selling plan + name label) by key, so that add
    // needs a line of its own; every other add must merge with an identical line already in the cart.
    const opensUpsellModal = !this.isRegularProduct && !document.body.classList.contains("template-collection");
    if (opensUpsellModal) {
      t.append("properties[_timestamp]", Date.now());
    }
    (e = { method: "POST", headers: { Accept: "application/javascript", "X-Requested-With": "XMLHttpRequest" } }),
      (e.body = t),
      this._disableButtons(),
      fetch("" + window.routes.cart_add_url, e)
        .then((e) => e.json())
        .then((e) => {
          e.status
            ? (theme.utils.subscriptions.publish(window.PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: t.get("id"),
                errors: e.errors || e.description,
                message: e.message,
              }),
              this.handleErrorMessage(e.description),
              (this.error = !0),
              this._enableButtons())
            : (this.error || theme.utils.subscriptions.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: "product-form", productVariantId: t.get("id") }),
              (this.error = !1),
              this._handleButtonState(this.buttonState.ADDED),
              opensUpsellModal ? this._handleSubscriptionProductSuccess(e) : this._showCartDrawer());
        })
        .catch((e) => {
          this.handleErrorMessage(e.description), console.error(e), this._enableButtons();
        });
  }
  _showCartDrawer() {
    if (window?.Rebuy?.SmartCart) {
      window.Rebuy.SmartCart.show();
    } else {
      const cartDrawer = document.querySelector("#CartDrawer");
      if (cartDrawer && typeof cartDrawer.open === "function") {
        cartDrawer.open();
      }
    }
  }
  _handleSubscriptionProductSuccess(cartResponse) {
    setTimeout(() => {
      this.upsellModal.open(this.productHandle, cartResponse, !1, this.allowCustomLabel);
    }, 500);
  }
  _highlightSelectError() {
    if (!this.selectVariant) return;
    this.selectVariant.style.border = "2px solid #ef4444";
    this.selectVariant.style.animation = "shake 0.3s";
    setTimeout(() => {
      this.selectVariant.style.border = "";
      this.selectVariant.style.animation = "";
    }, 1000);
  }
  handleErrorMessage(e = !1) {
    (this.errorMessageWrapper = this.querySelector(this._selectors.error)),
      e ? ((this.errorMessageWrapper.innerHTML = e), this.errorMessageWrapper.classList.remove("hidden")) : this.errorMessageWrapper.classList.add("hidden");
  }
  _updatePrice(e, t) {
    const { oneTime: s, subscription: i } = e;
    e = this.querySelector("[js-price-label-no-variant]");
    !t && e ? e.classList.remove("hidden") : e && e.classList.add("hidden");
    const r = this.querySelectorAll("[js-current-price]"),
      a = this.querySelectorAll("[js-compare-price]");
    if (
      (r.forEach((e) => (e.innerHTML = theme.utils.formatMoney(s.price))),
      a.forEach((e) => {
        s.compare ? ((e.innerHTML = theme.utils.formatMoney(s.compare)), e.classList.remove("hidden")) : e.classList.add("hidden");
      }),
      i)
    ) {
      const e = this.querySelectorAll("[js-subscription-current-price]"),
        t = this.querySelectorAll("[js-subscription-compare-price]");
      e.forEach((e) => (e.innerHTML = theme.utils.formatMoney(i.price))),
        t.forEach((e) => {
          i.compare ? ((e.innerHTML = theme.utils.formatMoney(i.compare)), e.classList.remove("hidden")) : e.classList.add("hidden");
        });
    }
  }
  _updateDiscount(e) {
    var t = this.querySelector("[js-card-discount-wrapper]");
    t && (e ? ((this.querySelector("[js-card-discount]").innerHTML = e + "%"), t.classList.remove("hidden")) : t.classList.add("hidden"));
  }
  _getDiscountPercentage(e, t) {
    var s = theme.utils.extractWeightAndUnit(e.title)["weight"],
      i = theme.utils.extractWeightAndUnit(t.title)["weight"];
    let r = 0,
      a = (0 < s && (r = Number((e.price / s).toFixed(2))), 0),
      n = (0 < i && (a = Number((t.price / i).toFixed(2))), 0);
    return 0 < r && 0 < a && ((e = r - a), (n = Math.round((e / r) * 100))), n;
  }
  _handleButtonState(e) {
    switch (e) {
      case this.buttonState.AVAILABLE: {
        (this.buttonLabel.innerHTML = "Læg i kurv"), this.button.removeAttribute("disabled");
        var t = this.button.querySelector(this._selectors.loader);
        t && t.removeAttribute("loading");
        break;
      }
      case this.buttonState.UNAVAILABLE:
        (this.buttonLabel.innerHTML = "Udsolgt"), this.button.setAttribute("disabled", "");
        break;
      case this.buttonState.SELECT_VARIANT:
        (this.buttonLabel.innerHTML = "Vælg " + this.variantLabel), this.button.setAttribute("disabled", "");
        break;
      case this.buttonState.ADDED:
        this.button.setAttribute("disabled", ""),
          (this.buttonLabel.innerHTML = "Tilføjet!"),
          this.buttonSuccessIcon.classList.remove("hidden"),
          setTimeout(() => {
            this.buttonSuccessIcon.classList.add("hidden"), this._handleButtonState(this.buttonState.AVAILABLE);
          }, 2e3);
        break;
      default:
        console.error("Invalid button state");
    }
  }
  _disableButtons() {
    this.button.setAttribute("disabled", "");
    var e = this.button.querySelector(this._selectors.loader);
    e && e.setAttribute("loading", "");
  }
  _enableButtons() {
    this.button.removeAttribute("disabled");
    var e = this.button.querySelector(this._selectors.loader);
    e && e.removeAttribute("loading");
  }
}
class ProductManualOptions extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this._selectors = {
        productContainer: "s-product",
        containers: { markers: "[js-slider-markers]", labels: "[js-slider-labels]" },
        title: "[js-variant-title]",
        price: "[js-variant-price]",
        comparePrice: "[js-variant-compare]",
        variantData: "script#ProductVariants",
        variantInput: "[js-size-variant]",
        form: "form",
      }),
      (this.productElement = document.querySelector(this._selectors.productContainer)),
      (this.allowCustomLabel = "true" === this.productElement.getAttribute("data-allow-custom-label")),
      (this.productData = JSON.parse(document.querySelector("#ProductJSON")?.innerHTML) ?? !1),
      (this.variants = this.productData.variants),
      !this.productElement || !this.productData)
    )
      return console.error("Manual options have failed to fetch product");
    (this.productHandle = this.productData.handle),
      (this.slider = this.querySelector('input[type="range"]')),
      console.log("this.slider: ", this.slider),
      (this.markersContainer = this.querySelector(this._selectors.containers.markers)),
      (this.labelsContainer = this.querySelector(this._selectors.containers.labels)),
      (this.variantInput = this.querySelector(this._selectors.variantInput)),
      (this.variantTitle = this.querySelector(this._selectors.title)),
      (this.price = this.querySelector(this._selectors.price)),
      (this.comparePrice = this.querySelector(this._selectors.comparePrice)),
      (this.form = this.querySelector(this._selectors.form)),
      (this.productForm = this.productElement.querySelector("form[js-product-form]")),
      (this.upsellModal = document.querySelector("product-upsell")),
      (this.productContainer = document.querySelector(this._selectors.productContainer));
  }
  connectedCallback() {
    document.addEventListener("ProductManualOptionDrawer:open", this.setupSlider.bind(this)),
      this.productContainer.addEventListener("variant:change", this.handleVariantChange.bind(this)),
      this.slider.addEventListener("change", this.handleChange.bind(this)),
      this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
  }
  setupSlider() {
    (this.values = this.productData.variants.map((e) => {
      var t = this.productElement.getDiscountPercentage(this.productData.variants[0], e);
      return { value: this.getVariantValue(e.title), label: `Spar ${t}%` };
    })),
      (this.slider.min = 0),
      (this.slider.max = this.values.length - 1),
      (this.slider.step = 0.01),
      this.createMarkers();
  }
  getVariantValue(e) {
    return e.replace(/\D/g, "");
  }
  handleChange(e = null, t = !1) {
    let s;
    if (e) s = Math.round(parseFloat(e.target.value));
    else {
      if (!1 === t) return void console.error("Failed to handle manual option change.");
      s = t;
    }
    this.slider.value = s;
    e = this.variants[s];
    (this.variantInput.value = e.id),
      (this.variantTitle.innerHTML = e.title),
      (this.price.innerHTML = theme.utils.formatMoney(e.selling_plan_allocations[0].price)),
      (this.comparePrice.innerHTML = theme.utils.formatMoney(e.price));
  }
  createMarkers() {
    const i = this.slider.offsetWidth,
      r = i - 20;
    console.log("this.values: ", this.values),
      this.values.forEach(({ label: e }, t) => {
        var t = (((t / (this.values.length - 1)) * r + 10) / i) * 100,
          s = document.createElement("div");
        s.classList.add("size-slider__markers__item"),
          (s.style.left = t + "%"),
          this.markersContainer.appendChild(s),
          e &&
            ((s = document.createElement("div")).classList.add("size-slider__label"),
            (s.textContent = e),
            (s.style.left = t + "%"),
            this.labelsContainer.appendChild(s));
      });
  }
  handleVariantChange(e) {
    const t = e.detail.variant;
    e = this.variants.findIndex((e) => e.id == t.id);
    this.handleChange(null, e);
  }
  _isStarterKitAdded() {
    return (
      !(!window?.Rebuy?.Cart || !window.Rebuy.Cart?.items()) &&
      window.Rebuy.Cart.items().some((e) => "Starter Kit" === e.product_type && "Food Bag Combo" === e.properties._type)
    );
  }
  _buildFormConfig(e, t = !1) {
    var s = { method: "POST", headers: { Accept: "application/javascript", "X-Requested-With": "XMLHttpRequest" } };
    return (
      this._isStarterKitAdded() || !t
        ? (e.append("properties[_timestamp]", Date.now()), (s.body = e))
        : ((e = [
            { id: e.get("id"), quantity: e.get("quantity"), properties: { _timestamp: Date.now() }, selling_plan: e.get("selling_plan") },
            { id: t, quantity: 1, properties: { _type: "Food Bag Combo" } },
          ]),
          (s.headers["Content-Type"] = "application/json"),
          (s.body = JSON.stringify({ items: e }))),
      s
    );
  }
  onSubmitHandler(e) {
    e.preventDefault();
    var e = new FormData(this.form),
      t = this.productForm.getAttribute("data-starter-kit") ?? !1,
      e = this._buildFormConfig(e, t);
    fetch("" + window.routes.cart_add_url, e)
      .then((e) => e.json())
      .then((e) => {
        this.upsellModal.open(this.productHandle, e, this.productData, this.allowCustomLabel);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {});
  }
}
class BundleOptions extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this._selectors = { variantInput: "[js-variant-input]" }),
      (this._events = { change: "variant:change", fetchBefore: "variant:fetch:before", fetchAfter: "variant:fetch:after", fetchError: "variant:fetch:error" }),
      !this.dataset.product)
    )
      return console.error("Could not find product data.");
    var e = document.getElementById(this.dataset.product);
    e && (this._product = JSON.parse(e.innerHTML)),
      this.dataset.defaultVariant && (this._defaultVariant = this.dataset.defaultVariant),
      this._defaultVariant && this._product && (this._currentVariant = this._getVariant(this._defaultVariant)),
      (this._handleVariantChange = this._handleVariantChange.bind(this));
  }
  connectedCallback() {
    (this._variantSelectors = [...this.querySelectorAll(this._selectors.variantInput)]), this._variantSelectors && this._setupListeners();
  }
  _setupListeners() {
    this._variantSelectors.forEach((e) => {
      e.addEventListener("change", this._handleVariantChange);
    });
  }
  _handleVariantChange(e) {
    this.querySelectorAll("[js-option-item]").forEach((e) => {
      e.classList.remove("selected");
    }),
      e.target.closest("[js-option-item]").classList.add("selected"),
      this._updateVariant(e.target.value),
      this._updateHistoryState();
  }
  _updateVariant(e) {
    e = this._getVariant(e);
    this._currentVariant || (this._currentVariant = e),
      this.dispatchEvent(new CustomEvent(this._events.change, { detail: { variant: e, priceChange: this._hasPriceChanged(e) }, bubbles: !0 })),
      (this._currentVariant = e);
  }
  _getVariant(s) {
    if (this._product && s) {
      var e = this._product["variants"];
      let t;
      return (
        e.forEach((e) => {
          e.id == s && (t = e);
        }),
        t || void 0
      );
    }
  }
  _hasPriceChanged(e) {
    return !(!e || !this._currentVariant || (e.price === this._currentVariant.price && e.compare_at_price === this._currentVariant.compare_at_price));
  }
  _updateHistoryState() {
    var e;
    history.replaceState &&
      this._currentVariant?.id &&
      ((e = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + this._currentVariant.id),
      window.history.replaceState({ path: e }, "", e));
  }
  disconnectedCallback() {
    this._optionSelectors.forEach((e) => e.removeEventListener("change", this._handleOptionChange));
  }
}

class LoadingSpinner extends HTMLElement {
  constructor() {
    super();
    var e = document.createElement("template");
    (e.innerHTML = `
    <style>
      :host {
        display: none;
        position: absolute;        
        top: 0; right: 0; bottom: 0; left: 0;
        width: 100%;
        height: 100%;
        justify-content: center;
        align-items: center;
      }

      :host([loading]) {
        display: flex;
      }

      .background {
        position: absolute;        
        top: 0; right: 0; bottom: 0; left: 0;
        width: 100%;
        height: 100%;
        background: var(--background, 'transparent');
        z-index: 1;
      }

      .loading-spinner {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        width: var(--width, 20px);
        height: var(--height, 20px);
        color: var(--color, black);
        z-index: 2;
        animation: loading-spinner 1s linear infinite;
      }

      .loading-spinner svg{
        fill: currentColor;
        width: 100%;
      }

      @keyframes loading-spinner {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    </style>

    <div class="background"></div>
    <div class="loading-spinner">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 145 145">
        <path d="M72.5,145C32.6,145,.07,112.54,0,72.64H5c.07,37.14,30.35,67.36,67.5,67.36s67.5-30.28,67.5-67.5S109.72,5,72.5,5V0c39.98,0,72.5,32.52,72.5,72.5s-32.52,72.5-72.5,72.5Z" />
      </svg>
    </div>
    `),
      this.attachShadow({ mode: "open" }),
      this.shadowRoot.appendChild(e.content.cloneNode(!0));
  }
}
class PredictiveSearch extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = { allResults: "[js-search-all-results]", close: "[js-search-close]", resultsCount: "[js-search-result-count]" }),
      (this.onKeyDown = this.onKeyDown.bind(this)),
      (this.input = this.querySelector('input[type="search"]')),
      (this.resultsCount = this.querySelector(this._selectors.resultsCount)),
      (this.viewAllResults = this.querySelector("[js-search-all-results]")),
      (this.predictiveSearchResults = this.querySelector("[js-predictive-search]")),
      this.input.addEventListener(
        "input",
        theme.utils
          .debounce((e) => {
            this.onChange(e);
          }, 300)
          .bind(this),
      ),
      this.input.addEventListener("keydown", this.onKeyDown);
  }
  onKeyDown(e) {
    "Enter" === e.key && (e.preventDefault(), (window.location.href = `${routes.search_url}?q=${this.input.value}&type=product`));
  }
  onChange() {
    var e = this.input.value.trim();
    e.length ? this.getSearchResults(e) : this.close();
  }
  getSearchResults(i) {
    fetch(routes.search_url + `?q=${i}&type=product&section_id=search-main`)
      .then((e) => {
        if (e.ok) return e.text();
        throw ((e = new Error(e.status)), this.close(), e);
      })
      .then((e) => {
        this.predictiveSearchResults.innerHTML = "";
        var e = new DOMParser().parseFromString(e, "text/html").querySelector("#shopify-section-search-main"),
          t = e.querySelector(this._selectors.resultsCount),
          e = e.querySelectorAll("ul[js-search-results] product-card");
        if (e.length)
          for (var s of Array.from(e).slice(0, 4)) this.predictiveSearchResults.appendChild(s), this.predictiveSearchResults.classList.remove("hidden");
        else this.predictiveSearchResults.classList.add("hidden");
        4 <= e.length
          ? (this.viewAllResults.parentNode.classList.remove("hidden"),
            (e = routes.search_url + `?q=${i}&type=product`),
            this.viewAllResults.setAttribute("href", e))
          : this.viewAllResults.parentNode.classList.add("hidden"),
          (this.resultsCount.innerHTML = t.innerHTML),
          this.resultsCount.classList.remove("hidden");
      })
      .catch((e) => {
        this.close(), console.error("An error has occured whilst attempting to get search results: ", e);
      });
  }
  open() {
    this.predictiveSearchResults.classList.remove("hidden");
  }
  close() {
    (this.input.value = ""),
      this.resultsCount.classList.add("hidden"),
      this.predictiveSearchResults.classList.add("hidden"),
      this.viewAllResults.parentNode.classList.add("hidden");
  }
}
class FilterSort extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        container: "filter-sort",
        form: "[js-filter-form]",
        filter: "[js-filter]",
        clearAll: "[js-clear-all]",
        loader: "loading-spinner",
        filterValue: "[js-filter-value]",
        valuesContainer: "[js-filter-values]",
      }),
      (this._events = { change: "filter:change" }),
      (this._cache = []),
      (this._debouncedOnSubmit = theme.utils.debounce((e) => {
        this._onSubmitHandler(e);
      }, 500));
  }
  connectedCallback() {
    if (
      ((this._scope = this.dataset.scope),
      (this._form = this.querySelector(this._selectors.form)),
      (this._clearAll = this.querySelector(this._selectors.clearAll)),
      (this._loader = this.querySelector(this._selectors.loader)),
      this._setListeners(),
      !this._scope)
    )
      throw new Error("filter-sort must have scope set. See file for docs.");
  }
  _setListeners() {
    window.addEventListener("popstate", this._onHistoryChange),
      this._form.addEventListener("input", this._debouncedOnSubmit),
      this._form.addEventListener("change", this._debouncedOnSubmit),
      this._clearAll.addEventListener("click", this._onClearAllHandler),
      document.addEventListener("filter:change", this._onFilterChange),
      document.addEventListener("filter:clearAll", this._onClearAllHandler);
  }
  _renderComponent(e) {
    var e = e.querySelector(`${this._selectors.container}[data-scope="${this._scope}"]`) || e.querySelector(this._selectors.container),
      t = e.dataset.totalProducts;
    this.setAttribute("data-total-products", t), theme.utils.refreshElements([this._selectors.filter], e, this);
    // Note: Removed s-accordion.connectedCallback() - now using native <details> elements via 1337-accordion
  }
  _onSubmitHandler = (e) => {
    e.preventDefault();
    (e = new FormData(this._form)), (e = new URLSearchParams(e).toString());
    this._propagateChange(e);
  };
  _onClearAllHandler = (e) => {
    e.preventDefault();
    this._propagateChange("");
  };
  _onFilterChange = (e) => {
    var { parsedHTML: e, scope: t } = e.detail;
    t !== this._scope && this._renderComponent(e);
  };
  _onHistoryChange = (e) => {
    e = e.state ? e.state.searchParams : FilterSort.searchParamsInitial;
    e !== FilterSort.searchParamsPrev && (this._propagateChange(e, !1), (this._onSubmitHandlerEvent = null));
  };
  async _propagateChange(e, t = !0) {
    this._loader.setAttribute("loading", "");
    const s = window.location.pathname + "?" + e;
    var i = (e) => e.url === s,
      i = this._cache.some(i) ? this._markupFromCache(i) : await this._markupFromFetch(s);
    document.dispatchEvent(new CustomEvent("filter:change", { detail: { parsedHTML: i, scope: this._scope } })),
      this._renderComponent(i),
      t && history.pushState({ searchParams: e }, "", "" + window.location.pathname + (e && "?".concat(e))),
      this._loader.removeAttribute("loading", "");
  }
  _markupFromCache(e) {
    e = this._cache.find(e).html;
    return new DOMParser().parseFromString(e, "text/html");
  }
  _markupFromFetch(s) {
    let i = this._cache;
    return fetch(s)
      .then((e) => e.text())
      .then((e) => {
        var t = new DOMParser().parseFromString(e, "text/html");
        return (i = [...i, { html: e, url: s }]), t;
      });
  }
}
(FilterSort.searchParamsInitial = window.location.search.slice(1)), (FilterSort.searchParamsPrev = window.location.search.slice(1));
class ActiveFilters extends HTMLElement {
  constructor() {
    super(), (this._selectors = { remove: "[js-remove]", clearAll: "[js-clear-all]" }), (this._refresh = ["[js-active-filter]"]);
  }
  connectedCallback() {
    document.addEventListener("filter:change", this._handleFilterChange), this._setListeners();
  }
  _setListeners() {
    var e = this.querySelector(this._selectors.clearAll);
    e && e.addEventListener("click", this._triggerClearAll),
      this.querySelectorAll(this._selectors.remove).forEach((e) => e.addEventListener("click", this._handleRemove));
  }
  _handleRemove = (e) => {
    e.preventDefault();
    var { name: e, value: t } = e.currentTarget.dataset,
      e = document.querySelector(`filter-sort [name="${e}"][value="${t}"]`);
    e && e.click();
  };
  _handleFilterChange = (e) => {
    (e = e.detail.parsedHTML), (e = e.querySelector("active-filters"));
    (this.innerHTML = e.innerHTML), this._setListeners();
  };
  _triggerClearAll = (e) => {
    e.preventDefault(), e.stopImmediatePropagation(), document.dispatchEvent(new CustomEvent("filter:clearAll"));
  };
}
class PriceRange extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        slider: "[js-price-range-slider]",
        minInput: "[js-range-min-value]",
        maxInput: "[js-range-max-value]",
        minInputLabel: "[js-range-min-label]",
        maxInputLabel: "[js-range-max-label]",
      }),
      (this.config = { min: 0, max: 1e3, step: 1 }),
      (this.minInput = this.querySelector(this._selectors.minInput)),
      (this.maxInput = this.querySelector(this._selectors.maxInput)),
      (this.minInputLabel = this.querySelector(this._selectors.minInputLabel)),
      (this.maxInputLabel = this.querySelector(this._selectors.maxInputLabel)),
      (this.slider = this.querySelector(this._selectors.slider)),
      (this.onRangeChange = this.onRangeChange.bind(this)),
      (this.debouncedEventTrigger = theme.utils.debounce((e) => {
        this.rangeEventTrigger();
      }, 400)),
      document.addEventListener("FilterSortDrawer:open", this._initSlider.bind(this));
  }
  connectedCallback() {
    this.onRangeChange(), this._initSlider();
  }
  _initSlider() {
    var e = Math.round(Number(this.minInput.value) || this.config.min),
      t = Math.round(Number(this.maxInput.value) || this.config.max);
    window.rangeSlider(this.slider, {
      min: this.config.min,
      max: this.config.max,
      step: this.config.step,
      value: [e, t],
      onInput: (e) => {
        this.onRangeChange(!0, e), this.debouncedEventTrigger();
      },
    });
  }
  onRangeChange(e = !1, t) {
    var s,
      [t, i] = t || [],
      t = Math.round(Number(t) || Number(this.minInput.value) || this.config.min),
      i = Math.round(Number(i) || Number(this.maxInput.value) || this.config.max);
    (this.querySelector(this._selectors.minInputLabel).innerHTML = theme.utils.formatMoney(100 * t)),
      (this.querySelector(this._selectors.maxInputLabel).innerHTML = theme.utils.formatMoney(100 * i)),
      e &&
        ((e = this.minInput || this.querySelector(this._selectors.minInput)),
        (s = this.maxInput || this.querySelector(this._selectors.maxInput)),
        e && e.value !== t && (e.value = t),
        s) &&
        s.value !== i &&
        (s.value = i);
  }
  rangeEventTrigger() {
    [this.querySelector(this._selectors.minInput), this.querySelector(this._selectors.maxInput)].forEach((e) => {
      e && e.dispatchEvent(new Event("change", { bubbles: !0 }));
    });
  }
}
class MovingText extends HTMLElement {
  constructor() {
    super(), (this.container = this.querySelector("[js-anim-container]")), (this.items = this.querySelectorAll("li"));
  }
  connectedCallback() {
    this.createAnimation();
  }
  createAnimation() {
    let t = this.items.length,
      s = 0,
      i = this;
    !(function e() {
      for (let e = 0; e < t; e++) i.items[e].classList.remove("text-in", "text-out");
      i.items[s].classList.add("text-in"),
        setTimeout(() => {
          i.items[s].classList.add("text-out");
        }, 2800),
        setTimeout(() => {
          s == t - 1 ? (s = 0) : s++, e();
        }, 3e3);
    })();
  }
}
customElements.define("s-drawer", Drawer),
  customElements.define("s-modal", Modal),
  customElements.define("s-accordion", Accordion),
  customElements.define("s-tabs", Tabs),
  customElements.define("s-carousel", Carousel),
  customElements.define("s-header", SiteHeader),
  customElements.define("mega-menu", MegaMenu),
  customElements.define("product-card", ProductCard),
  customElements.define("product-options", ProductOptions),
  customElements.define("product-manual-options", ProductManualOptions),
  // moved to global.js
  // customElements.define("product-upsell", ProductUpsell),
  customElements.define("product-starter-kit", ProductStarterKit),
  customElements.define("bundle-options", BundleOptions),
  // moved to global.js
  // customElements.define("quantity-input", QuantityInput),
  customElements.define("loading-spinner", LoadingSpinner),
  customElements.define("predictive-search", PredictiveSearch),
  customElements.define("filter-sort", FilterSort),
  customElements.define("active-filters", ActiveFilters),
  customElements.define("price-range", PriceRange),
  customElements.define("moving-text", MovingText);
class CollectionGrid extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        productGrid: "[js-products-grid]",
        toggleGrid: "[js-toggle-grid]",
        sortTrigger: "[js-collection-sort-trigger]",
        filterSort: "[js-filter-sort]",
        loadMoreButton: "[js-load-more]",
        productCount: "[js-product-count]",
        productsSeen: "[js-products-seen]",
        progressBar: "[js-progress-bar]",
        totalProducts: "[js-total-products]",
        totalProductsStyle: "[js-total-products-style]",
      }),
      (this._refresh = ["[js-products-grid]", "[js-pagination]"]),
      (this._cache = []),
      (this.currentProductsCount = 0),
      (this.totalProductsCount = parseInt(this.dataset.totalProducts, 10));
  }
  connectedCallback() {
    (this.sortTrigger = this.querySelector(this._selectors.sortTrigger)),
      this._setListeners(),
      this._initializeProductCount(),
      this._updateHeaderCount(),
      this._updateProgressBar(),
      this._updateTotalProducts();
  }
  _setListeners() {
    document.addEventListener("filter:change", this._handleFilterChange);
    var e = this.querySelector(this._selectors.loadMoreButton);
    e && e.addEventListener("click", this._handleLoadMore), this.sortTrigger && this.sortTrigger.addEventListener("change", this._handleSortTrigger);
  }
  _handleSortTrigger = (e) => {
    e.preventDefault();
    var t = document.querySelector("[js-filter-form-sort]"),
      e = ((t.value = e.currentTarget.value), new Event("change", { bubbles: !0 }));
    t.dispatchEvent(e);
  };
  _initializeProductCount() {
    var e = this.querySelectorAll(this._selectors.productGrid + " .collection-grid__product");
    this.currentProductsCount = e.length;
  }
  _handleFilterChange = (e) => {
    var e = e.detail["parsedHTML"],
      t = e.querySelector(`[data-id="${this.dataset.id}"]`),
      e = e.querySelector("filter-sort");
    e
      ? (e = e.dataset.totalProducts) && ((this.totalProductsCount = parseInt(e, 10)), this.setAttribute("data-total-products", e), this._updateTotalProducts())
      : console.warn("filter-sort element not found in parsedHTML"),
      theme.utils.refreshElements(this._refresh, t, this),
      this._initializeProductCount(),
      this._updateHeaderCount(),
      this._updateProgressBar(),
      this._setListeners();
  };
  _updateTotalProducts() {
    var e = this.querySelectorAll(this._selectors.totalProducts),
      t = this.querySelectorAll(this._selectors.totalProductsStyle);
    e.forEach((e) => {
      e.textContent = this.totalProductsCount;
    }),
      t.forEach((e) => {
        e.textContent = this.totalProductsCount;
      });
  }
  _handleLoadMore = () => {
    const i = this.querySelector(this._selectors.loadMoreButton);
    var e = i.getAttribute("data-next-page");
    e
      ? fetch(e)
          .then((e) => e.text())
          .then((e) => {
            var e = new DOMParser().parseFromString(e, "text/html"),
              t = e.querySelector(this._selectors.productGrid)?.innerHTML,
              s = e.querySelectorAll(".collection-grid__product"),
              e = e.querySelector(this._selectors.loadMoreButton);
            if (!t || 0 === s.length) throw new Error("No products found in the fetched document.");
            this.querySelector(this._selectors.productGrid).insertAdjacentHTML("beforeend", t),
              (this.currentProductsCount += s.length),
              this._updateHeaderCount(),
              this._updateProgressBar(),
              e && (t = e.getAttribute("data-next-page")) ? i.setAttribute("data-next-page", t) : i.remove();
          })
          .catch((e) => console.error("Error loading more products:", e))
      : console.error("No next page URL found.");
  };
  _updateHeaderCount() {
    this.querySelectorAll(this._selectors.productCount).forEach((e) => {
      e.textContent = this.currentProductsCount;
    });
  }
  _updateProgressBar() {
    var e = this.querySelector(this._selectors.productCount),
      t = this.querySelector(this._selectors.progressBar);
    e && t && ((e = (this.currentProductsCount / this.totalProductsCount) * 100), (t.style.width = e + "%"));
  }
}
class ProductMain extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        price: { current: "[js-current-price]", compare: "[js-compare-price]" },
        variantOption: "[js-option-item]",
        variantInput: "[js-variant-input]",
        discountPercentageWrapper: "[js-discount-percentage-wrapper]",
        discountPercentage: "[js-discount-percentage]",
        addToCart: "[js-add-to-cart]",
        error: "[js-error-message]",
        form: "[js-product-form]",
        loader: "loading-spinner",
        schedulePicker: "[js-schedule-picker]",
        atcWrapper: ".product-form__atc",
        stickyAtc: ".product-form__atc.product-form__atc--sticky",
        quantitySelector: "[js-quantity-input]",
        badgeContainer: "[js-badge-container]",
        popularBadge: "[js-popular-badge]",
        anchorLink: "[js-anchor-link]",
        addons: "[js-product-addon]",
      }),
      (this._events = { change: "variant:change", addons: { change: "startkit:change" } }),
      (this.cookieConfig = { name: "vuffeli-funnel-result" });
  }
  connectedCallback() {
    (this.isBundle = "true" === this.getAttribute("data-is-bundle") ?? !1),
      (this.isSubscription = "true" === this.getAttribute("data-is-subscription") ?? !1),
      (this.isRegularProduct = !this.isBundle && !this.isSubscription),
      (this.productData = JSON.parse(this.querySelector("#ProductJSON")?.innerHTML) ?? !1),
      (this.productHandle = this.productData.handle),
      (this.additionalItems = []),
      (this.form = this.querySelector(this._selectors.form)),
      (this.buttons = this.querySelectorAll(this._selectors.addToCart)),
      (this.price = { current: this.querySelectorAll(this._selectors.price.current), compare: this.querySelectorAll(this._selectors.price.compare) }),
      (this.quantitySelector = this.querySelector(this._selectors.quantitySelector)),
      this.quantitySelector && this.quantitySelector.addEventListener("change", this._handleQuantityChange),
      (this.anchorLinks = this.querySelectorAll(this._selectors.anchorLink)),
      this.anchorLinks.forEach((e) => e.addEventListener("click", this._handleAnchorClick)),
      (this.allowCustomLabel = "true" === this.getAttribute("data-allow-custom-label")),
      (this.isBundle || this.isSubscription) &&
        ((this.addons = this.querySelector(this._selectors.addons)),
        (this.isSchedulesPreset = !1),
        (this.variantOptions = this.querySelectorAll(this._selectors.variantOption)),
        (this.variantInputs = this.querySelectorAll(this._selectors.variantInput)),
        (this.schedulePicker = this.querySelector(this._selectors.schedulePicker)),
        (this.discountPercentage = this.querySelector(this._selectors.discountPercentage)),
        (this.discountPercentageWrapper = this.querySelector(this._selectors.discountPercentageWrapper)),
        (this._updateBundlePrice = this._updateBundlePrice.bind(this)),
        this.isBundle && this._initBundle(),
        this.isSubscription) &&
        this._initSubscription(),
      this._initProductForm();
  }
  _initBundle() {
    this._updateOptionLabels(!0);
    var e = this._getSelectedVariant(),
      e = (this._updateDiscountAmount(e), theme.utils.getCookie(this.cookieConfig.name));
    e &&
      ((this._selectors = {
        ...this._selectors,
        cookieOnlyItem: "[js-cookie-only-item]",
        dog: {
          container: "[js-dog-info]",
          name: "[js-dog-info-name]",
          breed: "[js-dog-info-breed]",
          recommendations: { grams: "[js-dog-recommend-grams]", weight: "[js-dog-recommend-weight]", schedule: "[js-dog-recommend-schedule]" },
        },
      }),
      this._handleFunnelRedirect(JSON.parse(atob(e))));
  }
  _initSubscription() {
    this.subscriptionTypeInputs = {
      types: this.querySelectorAll('input[name="subscription-type"]'),
      subscription: this.querySelector("[js-radio-subscription]"),
      oneTime: this.querySelector("[js-radio-one-time]"),
    };
    const t = () => {
      var e = this._getSelectedVariant(),
        t = this.subscriptionTypeInputs.subscription.checked,
        s = t ? 15 : 0;
      this._updateOptionLabels(t), this._updateSubscriptionPrice(e), this._updateDiscountAmount(e, s);
    };
    t(),
      this.schedulePicker.addEventListener("change", () => {
        this.subscriptionTypeInputs.subscription.click(), this._updateDiscountAmount(this._getSelectedVariant(), 15);
      }),
      this.subscriptionTypeInputs.types.forEach((e) => e.addEventListener("change", t));
  }
  _initProductForm() {
    (this.atcWrapper = this.form.querySelector(this._selectors.atcWrapper)),
      (this.stickyAtcWrapper = this.form.querySelector(this._selectors.stickyAtc)),
      (this.cart = document.querySelector("cart-drawer")),
      (this.cartDrawer = document.querySelector("#CartDrawer")),
      (this.upsellModal = document.querySelector("product-upsell")),
      this.buttons.forEach((t) => {
        t.addEventListener("click", (e) => this.onSubmitHandler(e, t));
      }),
      (this._handleStickyAtc = theme.utils.debounce(this._handleStickyAtc.bind(this), 50)),
      this.addEventListener(this._events.change, this._handleVariantChange),
      this.addEventListener(this._events.addons.change, this._handleAddons),
      document.addEventListener("scroll", this._handleStickyAtc);
  }
  _handleStickyAtc() {
    var e = window.scrollY;
    this.atcWrapper.offsetTop < e ? this.stickyAtcWrapper.classList.remove("invisible") : this.stickyAtcWrapper.classList.add("invisible");
  }
  _doesCartContainKit() {
    return (
      !(!window?.Rebuy?.Cart || !window.Rebuy.Cart?.items()) &&
      window.Rebuy.Cart.items().some((e) => "Starter Kit" === e.product_type && "Food Bag Combo" === e.properties._type)
    );
  }
  _buildFormConfig(e, { isOneTime: t = !1, isRegularProduct: s = !0, starterKitId: i = !1 } = {}) {
    const r = Object.fromEntries(e);
    var e = this._doesCartContainKit(),
      a = { method: "POST", headers: { Accept: "application/javascript", "X-Requested-With": "XMLHttpRequest", "Content-Type": "application/json" } };
    const n = { items: [] },
      o = { id: r.id, quantity: parseInt(r.quantity) || 1, properties: {} };
    r.selling_plan && !t && (o.selling_plan = r.selling_plan);
    t = Object.keys(r).filter((e) => e.startsWith("properties["));
    if (
      (0 < t.length &&
        t.forEach((e) => {
          var t = e.match(/properties\[(.*?)\]/)[1];
          o.properties[t] = r[e];
        }),
      this.isCookieValid &&
        this?.cookieData?.dog &&
        Object.entries(this.cookieData.dog).forEach(([e, t]) => {
          "name" === e.toLowerCase() ? (o.properties.Name = t) : (o.properties["_" + e.charAt(0).toUpperCase() + e.slice(1)] = t);
        }),
      s || (o.properties._timestamp = Date.now()),
      n.items.push(o),
      !e && i && n.items.push({ id: i, quantity: 1, properties: { _type: "Food Bag Combo" } }),
      0 < this.additionalItems.length)
    ) {
      const e = window.seed?.cartItems || [];
      this.additionalItems.forEach((t) => {
        e.some((e) => e.id === t) || n.items.push({ id: t, quantity: 1 });
      });
    }
    return (a.body = JSON.stringify(n)), a;
  }
  onSubmitHandler(e, s) {
    e.preventDefault();
    {
      (e = new FormData(this.form)),
        (s = this.isBundle ? "true" === s.getAttribute("data-one-time") : this.isSubscription && this.subscriptionTypeInputs.oneTime.checked),
        this.handleErrorMessage(),
        this._disableButtons();
      const t = this.form.getAttribute("data-starter-kit") ?? !1;
      (e = this._buildFormConfig(e, { isOneTime: s, isRegularProduct: this.isRegularProduct, starterKitId: t })),
        fetch("" + window.routes.cart_add_url, e)
          .then((e) => e.json())
          .then((e) => {
            e.status
              ? (this.handleErrorMessage(e.description), (this.error = !0))
              : ((this.error = !1),
                this.isBundle
                  ? this.isCookieValid
                    ? t
                      ? (document.location.href = "/discount/STARTKIT?redirect=/cart/checkout")
                      : (document.location.href = "/cart/checkout")
                    : this.upsellModal.open(this.productHandle, e, this.productData, this.allowCustomLabel)
                  : window.Rebuy.SmartCart.show());
          })
          .catch((e) => {
            this.handleErrorMessage(e.description), console.error(e);
          })
          .finally(() => {
            this._enableButtons();
          });
    }
  }
  handleErrorMessage(e = !1) {
    (this.errorMessageWrapper = this.querySelector(this._selectors.error)),
      e ? ((this.errorMessageWrapper.innerHTML = e), this.errorMessageWrapper.classList.remove("hidden")) : this.errorMessageWrapper.classList.add("hidden");
  }
  _handleVariantChange = (e) => {
    var { variant: e, priceChange: t } = e.detail;
    this._updateAddToCartState(e), e && t && (this._updatePrice(e), this._updateDiscountAmount(e), this.isSubscription) && this._updateOneTimeAmount(e);
  };
  _handleQuantityChange = (e) => {
    var t = this._getSelectedVariant();
    this._updatePrice(t, e.target.value);
  };
  _handleAddons = (e) => {
    var {} = e.detail,
      e = this._getSelectedVariant();
    this._updateBundlePrice(e, !1), this._updateAddToCartState(e);
  };
  _updateAddToCartState(n) {
    this.querySelectorAll(this._selectors.addToCart).forEach((e) => {
      var t,
        s,
        i = Boolean("true" === e.getAttribute("data-one-time")) ?? !1,
        r = e.querySelector("span") ?? e;
      let a = n?.price;
      this.addons && (({ priceChanged: t, amount: s } = this.addons.getPriceData()), t) && (a += s),
        n
          ? n.available
            ? i
              ? (e.classList.remove("hidden"), (r.textContent = "ENGANGSKØB • " + theme.utils.formatMoney(a)))
              : ((r.textContent = "KØB"), e.removeAttribute("disabled"))
            : i
              ? e.classList.add("hidden")
              : ((r.textContent = "Udsolgt"), e.setAttribute("disabled", ""))
          : i
            ? e.classList.add("hidden")
            : ((r.textContent = "Ikke tilgængelig"), e.setAttribute("disabled", ""));
    });
  }
  _updateOneTimeAmount(e) {
    this.querySelector("[js-default-price]").innerHTML = theme.utils.formatMoney(e.price);
  }
  _updateOptionLabels(c) {
    this.variantOptions.forEach((e, t) => {
      var s = {
        percentage: e.querySelector("[js-percentage-saving]"),
        costPerUnit: e.querySelector("[js-cost-per-unit]"),
        comparePrice: e.querySelector("[js-option-compare-price]"),
        price: e.querySelector("[js-option-price]"),
      };
      const i = e.getAttribute("data-variant-id");
      e = this.productData.variants.find((e) => e.id == i);
      let r = e.selling_plan_allocations[0].price,
        a = e.price;
      var { weight: n, unit: o } = theme.utils.extractWeightAndUnit(e.title);
      (a = c ? ((r = e.selling_plan_allocations[0].price), e.price) : ((r = e.price), e.compare_at_price ?? !1)),
        n &&
          o &&
          (n = 0 === t ? 15 : this.getDiscountPercentage(this.productData.variants[0], e)) &&
          s.percentage &&
          (s.percentage.classList.remove("hidden"), (s.percentage.innerHTML = `Spar ${n}%`)),
        r && s.price && (s.price.innerHTML = theme.utils.formatMoney(r));
    });
  }
  getDiscountPercentage(e, t) {
    if (this.isBundle && e.id === t.id) return 15;
    var s = theme.utils.extractWeightAndUnit(e.title)["weight"],
      i = theme.utils.extractWeightAndUnit(t.title)["weight"];
    let r = 0,
      a = (0 < s && (r = Number((e.price / s).toFixed(2))), 0),
      n = (0 < i && (a = Number((t.price / i).toFixed(2))), 0);
    return 0 < r && 0 < a && ((e = r - a), (n = Math.round((e / r) * 100))), n;
  }
  _updateBundlePrice(e, i = !1) {
    var r = this?.addons?.getPriceData(),
      t = new FormData(this.form);
    const s = i || t.get("selling_plan");
    if (s) {
      i = e.selling_plan_allocations.find((e) => e?.selling_plan_id == s);
      if (i.price && i.compare_at_price) {
        let t = i.price,
          s = i.compare_at_price;
        r?.amount && (t += r.amount),
          r?.amountCompare && (s += r.amountCompare),
          this.price?.current && this.price.current.forEach((e) => (e.innerHTML = theme.utils.formatMoney(t))),
          this.price?.compare && this.price.compare.forEach((e) => (e.innerHTML = theme.utils.formatMoney(s)));
      }
    }
  }
  _updateSubscriptionPrice(e) {
    var a = this.subscriptionTypeInputs.subscription.checked,
      n = {
        subscription: {
          price: this.querySelectorAll("[js-subscription-current-price]"),
          comparePrice: this.querySelectorAll("[js-subscription-compare-price]"),
        },
        total: { price: this.querySelectorAll("[js-total-price]"), compare: this.querySelectorAll("[js-total-compare]") },
      },
      o = e["selling_plan_allocations"];
    const t = new FormData(this.form).get("selling_plan");
    if (t) {
      o = o.find((e) => e?.selling_plan_id == t);
      if (o.price && o.compare_at_price) {
        const t = o.price,
          s = o.compare_at_price,
          i = a ? t : e.price,
          r = a ? e.price : e.compare_at_price;
        this.price.current.forEach((e) => {
          e.innerHTML = theme.utils.formatMoney(i);
        }),
          this.price.compare.forEach((e) => {
            r ? ((e.innerHTML = theme.utils.formatMoney(r)), e.classList.remove("hidden")) : e.classList.add("hidden");
          }),
          n.subscription.price.forEach((e) => {
            e.innerHTML = theme.utils.formatMoney(t);
          }),
          n.subscription.comparePrice.forEach((e) => {
            e.innerHTML = theme.utils.formatMoney(s);
          });
      }
    }
  }
  _updateDiscountAmount(e, t = null) {
    this?.discountPercentageWrapper &&
      this?.discountPercentage &&
      ((t = this.subscriptionTypeInputs?.subscription?.checked ? 15 : (t ?? this.getDiscountPercentage(this.productData.variants[0], e)))
        ? (this.discountPercentageWrapper.classList.remove("hidden"), (this.discountPercentage.innerHTML = t + "%"))
        : this.discountPercentageWrapper.classList.add("hidden"));
  }
  _updatePrice(t, s = 1) {
    this.isBundle
      ? this._updateBundlePrice(t)
      : this.isSubscription
        ? this._updateSubscriptionPrice(t)
        : t?.compare_at_price
          ? (this.price.current.forEach((e) => (e.innerHTML = theme.utils.formatMoney(t.price * s))),
            this.price.compare.forEach((e) => (e.innerHTML = theme.utils.formatMoney(t.comparePrice * s))))
          : this.price.current.forEach((e) => (e.innerHTML = theme.utils.formatMoney(t.price * s)));
  }
  _disableButtons() {
    this.buttons.forEach((e) => {
      e.setAttribute("disabled", "");
      e = e.querySelector(this._selectors.loader);
      e && e.setAttribute("loading", "");
    });
  }
  _enableButtons() {
    this.buttons.forEach((e) => {
      e.removeAttribute("disabled");
      e = e.querySelector(this._selectors.loader);
      e && e.removeAttribute("loading");
    });
  }
  _handleAnchorClick(e) {
    e.preventDefault();
    (e = e.currentTarget.getAttribute("href")), (e = document.querySelector(e));
    e &&
      (e.scrollIntoView({ behavior: "smooth", block: "start" }), e.classList.contains("accordion-header")) &&
      "false" === e.getAttribute("aria-expanded") &&
      e.click();
  }
  _getSelectedVariant() {
    let e;
    return (
      !!(e = this.variantInputs
        ? Array.from(this.variantInputs)
            .find((e) => e.checked)
            .closest("[js-option-item]")
            ?.getAttribute("data-variant-id")
        : this.querySelector("[js-master-variant-select]")?.value) && this._getVariant(e)
    );
  }
  _getVariant(t) {
    return this.productData.variants.find((e) => e.id == t) ?? !1;
  }
  _handleFunnelRedirect(o) {
    if (((this.isCookieValid = o && o?.chosenProduct?.shopifyProductId === this.productData.id), this.isCookieValid)) {
      const {
        deliveryFrequencyInWeeks: e,
        adultStarterKit: t,
        puppyStarterKit: s,
        foodGramsPerDay: i,
        kilogramsPerDelivery: r,
        shopifyProductVariantId: a,
        pickinessGuidance: n,
      } = (this.cookieData = o).chosenProduct;
      this._handleDogDetails(e, r, i, o.dog);
      var o = this.schedulePicker.querySelector("select"),
        c = this._getSellingPlanGroupId(e),
        o = ((o.value = c), Array.from(this.variantOptions).find((e) => e.getAttribute("data-variant-id") == a)),
        c =
          (o &&
            (o.querySelector("input").click(),
            (c = this._getVariant(a)),
            this._handleVariantChange({ detail: { variant: c, priceChange: !0 } }),
            this.variantOptions.forEach((e) => {
              e = e.querySelector(this._selectors.badgeContainer).querySelector(this._selectors.popularBadge);
              e && e.remove();
            }),
            (c = o.querySelector(this._selectors.badgeContainer)),
            (o = document.createElement("span")).classList.add("option-item__badge", "option-item__badge--veggie"),
            (o.innerHTML = "Mest populære"),
            c.prepend(o)),
          this.querySelectorAll(this._selectors.cookieOnlyItem));
      c && c.forEach((e) => e.classList.remove("hidden")), (t || s) && this._handleStarterKitSelection(t, s), n && this.additionalItems.push(49019415331143);
    }
  }
  _handleDogDetails(e, t, s, i) {
    var r,
      a = {
        container: this.querySelector(this._selectors.dog.container),
        name: this.querySelector(this._selectors.dog.name),
        breed: this.querySelector(this._selectors.dog.breed),
        recommendations: {
          grams: document.querySelectorAll(this._selectors.dog.recommendations.grams),
          weight: this.querySelector(this._selectors.dog.recommendations.weight),
          schedule: this.querySelector(this._selectors.dog.recommendations.schedule),
        },
      };
    a.container &&
      (a.container.classList.remove("hidden"),
      (r = i?.pureBreed || i?.breeds?.join(" / ") || null) ? (a.breed.innerHTML = r) : a.breed.classList.add("hidden"),
      i?.name ? (a.name.innerHTML = i.name) : a.name.classList.add("hidden"),
      a.recommendations.grams.forEach((e) => (e.innerHTML = Math.trunc(s) + " g")),
      (a.recommendations.weight.innerHTML = t + " kg"),
      (a.recommendations.schedule.innerHTML = e + " uge"));
  }
  _handleStarterKitSelection(e, t) {
    (e || t) && document.dispatchEvent(new CustomEvent("startkit:select", { detail: { selectedType: e ? "adult" : "puppy" } }));
  }
  _getSellingPlanGroupId(e) {
    const t = e + " Week(s)";
    e = this.productData.selling_plan_groups[0].selling_plans.find((e) => e.options.some((e) => e.value === t));
    return e ? e.id : null;
  }
}
class ProductBundle extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        price: { current: "[js-current-price]", compare: "[js-compare-price]" },
        variantOption: "[js-option-item]",
        variantInput: "[js-variant-input]",
        discountPercentageWrapper: "[js-discount-percentage-wrapper]",
        discountPercentage: "[js-discount-percentage]",
        addToCart: "[js-add-to-cart]",
        error: "[js-error-message]",
        form: "[js-product-form]",
        loader: "loading-spinner",
        schedulePicker: "[js-schedule-picker]",
        atcWrapper: ".product-form__atc",
        stickyAtc: ".product-form__atc--sticky",
        badgeContainer: "[js-badge-container]",
        popularBadge: "[js-popular-badge]",
        anchorLink: "[js-anchor-link]",
        addons: "[js-product-addon]",
      }),
      (this._events = { change: "variant:change", addons: { change: "startkit:change" } }),
      (this.cookieConfig = { name: "vuffeli-funnel-result" });
  }
  connectedCallback() {
    (this.productData = JSON.parse(this.querySelector("#ProductJSON")?.innerHTML) ?? !1),
      (this.productHandle = this.productData.handle),
      (this.additionalItems = []),
      (this.form = this.querySelector(this._selectors.form)),
      (this.buttons = this.querySelectorAll(this._selectors.addToCart)),
      (this.price = { current: this.querySelectorAll(this._selectors.price.current), compare: this.querySelectorAll(this._selectors.price.compare) }),
      (this.anchorLinks = this.querySelectorAll(this._selectors.anchorLink)),
      this.anchorLinks.forEach((e) => e.addEventListener("click", this._handleAnchorClick)),
      (this.allowCustomLabel = "true" === this.getAttribute("data-allow-custom-label")),
      (this.addons = this.querySelector(this._selectors.addons)),
      (this.variantOptions = this.querySelectorAll(this._selectors.variantOption)),
      (this.variantInputs = this.querySelectorAll(this._selectors.variantInput)),
      (this.schedulePicker = this.querySelector(this._selectors.schedulePicker)),
      (this.discountPercentage = this.querySelector(this._selectors.discountPercentage)),
      (this.discountPercentageWrapper = this.querySelector(this._selectors.discountPercentageWrapper)),
      (this._updatePrice = this._updatePrice.bind(this)),
      this._initBundle(),
      this._initCookieRedirects(),
      this._initProductForm();
  }
  _initBundle() {
    this._updateOptionLabels(!0);
    var e = this._getSelectedVariant();
    this._updateDiscountAmount(e),
      (this.subscriptionTypeInputs = {
        types: this.querySelectorAll('input[name="subscription-type"]'),
        subscription: this.querySelector("[js-radio-subscription]"),
        oneTime: this.querySelector("[js-radio-one-time]"),
      });
    const t = () => {
      var e = this._getSelectedVariant(),
        t = this.subscriptionTypeInputs.subscription.checked;
      this.subscriptionTypeInputs.subscription?.parentNode?.classList.remove("selected"),
        this.subscriptionTypeInputs.oneTime?.parentNode?.classList.remove("selected"),
        (t ? this.subscriptionTypeInputs.subscription : this.subscriptionTypeInputs.oneTime)?.parentNode?.classList.add("selected"),
        this._updateOptionLabels(t),
        this._updatePrice(e);
    };
    t(),
      this.schedulePicker.addEventListener("change", () => {
        this.subscriptionTypeInputs.subscription.click(),
          this.subscriptionTypeInputs.subscription?.parentNode?.classList.add("selected"),
          this.subscriptionTypeInputs.oneTime?.parentNode?.classList.remove("selected"),
          this._updateDiscountAmount(this._getSelectedVariant(), 15);
      }),
      this.subscriptionTypeInputs.types.forEach((e) => e.addEventListener("change", t));
  }
  _initCookieRedirects() {
    var e = theme.utils.getCookie(this.cookieConfig.name);
    e &&
      ((this._selectors = {
        ...this._selectors,
        cookieOnlyItem: "[js-cookie-only-item]",
        dog: {
          container: "[js-dog-info]",
          name: "[js-dog-info-name]",
          breed: "[js-dog-info-breed]",
          recommendations: { grams: "[js-dog-recommend-grams]", weight: "[js-dog-recommend-weight]", schedule: "[js-dog-recommend-schedule]" },
        },
      }),
      this._handleFunnelRedirect(JSON.parse(atob(e))));
  }
  _initProductForm() {
    (this.atcWrapper = this.form.querySelector(this._selectors.atcWrapper)),
      (this.stickyAtcWrapper = this.form.querySelector(this._selectors.stickyAtc)),
      (this.cart = document.querySelector("cart-drawer")),
      (this.cartDrawer = document.querySelector("#CartDrawer")),
      (this.upsellModal = document.querySelector("product-upsell")),
      (this.onSubmitHandler = this.onSubmitHandler.bind(this)),
      (this._buildFormConfig = this._buildFormConfig.bind(this)),
      this.form.addEventListener("submit", (e) => this.onSubmitHandler(e)),
      (this._handleStickyAtc = theme.utils.debounce(this._handleStickyAtc.bind(this), 50)),
      this.addEventListener(this._events.change, this._handleVariantChange),
      this.addEventListener(this._events.addons.change, this._handleAddons),
      document.addEventListener("scroll", this._handleStickyAtc);
  }
  _handleStickyAtc() {
    var e = window.scrollY;
    this.atcWrapper.offsetTop < e ? this.stickyAtcWrapper.classList.remove("invisible") : this.stickyAtcWrapper.classList.add("invisible");
  }
  _doesCartContainKit() {
    return (
      !(!window?.Rebuy?.Cart || !window.Rebuy.Cart?.items()) &&
      window.Rebuy.Cart.items().some((e) => "Starter Kit V2" === e.product_type && "Food Bag Combo" === e.properties._type)
    );
  }
  _buildFormConfig(e, t = {}) {
    var s = t?.isOneTime || !1,
      t = t?.starterKitId || !1;
    const i = Object.fromEntries(e);
    var e = this._doesCartContainKit(),
      r = { method: "POST", headers: { Accept: "application/javascript", "X-Requested-With": "XMLHttpRequest", "Content-Type": "application/json" } };
    const a = { items: [] },
      n = { id: i.id, quantity: parseInt(i.quantity) || 1, properties: { _timestamp: Date.now() } };
    i.selling_plan && !s ? (n.selling_plan = i.selling_plan) : s && i.selling_plan && delete i.selling_plan;
    s = Object.keys(i).filter((e) => e.startsWith("properties["));
    if (
      (0 < s.length &&
        s.forEach((e) => {
          var t = e.match(/properties\[(.*?)\]/)[1];
          n.properties[t] = i[e];
        }),
      this.isCookieValid &&
        this?.cookieData?.dog &&
        Object.entries(this.cookieData.dog).forEach(([e, t]) => {
          "name" === e.toLowerCase() ? (n.properties.Name = t) : (n.properties["_" + e.charAt(0).toUpperCase() + e.slice(1)] = t);
        }),
      a.items.push(n),
      !e && t && a.items.push({ id: t, quantity: 1, properties: { _type: "Food Bag Combo" } }),
      0 < this.additionalItems.length)
    ) {
      const e = window.seed?.cartItems || [];
      this.additionalItems.forEach((t) => {
        e.some((e) => e.id === t) || a.items.push({ id: t, quantity: 1 });
      });
    }
    return (r.body = JSON.stringify(a)), r;
  }
  onSubmitHandler(e) {
    e.preventDefault();
    (async () => {
      var e = new FormData(this.form),
        t = this.subscriptionTypeInputs.oneTime.checked;
      const s = this.form.getAttribute("data-starter-kit") ?? !1;
      this.handleErrorMessage(), this._disableButtons();
      (e = [[...e.entries()], { isOneTime: t, starterKitId: s }]), (t = this._buildFormConfig(...e));
      fetch("" + window.routes.cart_add_url, t)
        .then((e) => e.json())
        .then((e) => {
          e.status
            ? (this.handleErrorMessage(e.description), (this.error = !0))
            : ((this.error = !1),
              this.isCookieValid
                ? s
                  ? (document.location.href = "/discount/STARTKIT3?redirect=/cart/checkout")
                  : (document.location.href = "/cart/checkout")
                : this.upsellModal.open(this.productHandle, e, this.productData, this.allowCustomLabel));
        })
        .catch((e) => {
          this.handleErrorMessage(e.description), console.error(e);
        })
        .finally(() => {
          this._enableButtons();
        });
    })();
  }
  handleErrorMessage(e = !1) {
    (this.errorMessageWrapper = this.querySelector(this._selectors.error)),
      e ? ((this.errorMessageWrapper.innerHTML = e), this.errorMessageWrapper.classList.remove("hidden")) : this.errorMessageWrapper.classList.add("hidden");
  }
  _handleVariantChange = (e) => {
    var { variant: e, priceChange: t } = e.detail;
    this._updateAddToCartState(e), e && t && (this._updatePrice(e), this._updateDiscountAmount(e), this._updateOneTimeAmount(e));
  };
  _updateOneTimeAmount(e) {
    this.querySelector("[js-default-price]").innerHTML = theme.utils.formatMoney(e.price);
  }
  _handleAddons = (e) => {
    var {} = e.detail,
      e = this._getSelectedVariant();
    this._updatePrice(e, !1), this._updateAddToCartState(e);
  };
  _updateAddToCartState(r) {
    this.querySelectorAll(this._selectors.addToCart).forEach((e) => {
      var t,
        s,
        i = e.querySelector("span") ?? e;
      r.price;
      this.addons && ({ priceChanged: t, amount: s } = this.addons.getPriceData()),
        r
          ? r.available
            ? ((i.textContent = "Tilføj til kurv"), e.removeAttribute("disabled"))
            : ((i.textContent = "Udsolgt"), e.setAttribute("disabled", ""))
          : ((i.textContent = "Ikke tilgængelig"), e.setAttribute("disabled", ""));
    });
  }
  _updateOptionLabels(c) {
    this.variantOptions.forEach((e, t) => {
      var s = {
        percentage: e.querySelector("[js-percentage-saving]"),
        costPerUnit: e.querySelector("[js-cost-per-unit]"),
        comparePrice: e.querySelector("[js-option-compare-price]"),
        price: e.querySelector("[js-option-price]"),
      };
      const i = e.getAttribute("data-variant-id");
      e = this.productData.variants.find((e) => e.id == i);
      let r = e.selling_plan_allocations[0].price,
        a = e.price;
      var { weight: n, unit: o } = theme.utils.extractWeightAndUnit(e.title);
      (a = c ? ((r = e.selling_plan_allocations[0].price), e.price) : ((r = e.price), e.compare_at_price ?? !1)),
        n &&
          o &&
          (0 !== t || c
            ? (n = 0 === t && c ? 15 : this.getDiscountPercentage(this.productData.variants[0], e)) &&
              s.percentage &&
              (s.percentage.classList.remove("hidden"), (s.percentage.innerHTML = `Spar ${n}%`))
            : s.percentage.classList.add("hidden")),
        r && s.price && (s.price.innerHTML = theme.utils.formatMoney(r));
    });
  }
  getDiscountPercentage(e, t) {
    if (e.id === t.id) return 15;
    var s = theme.utils.extractWeightAndUnit(e.title)["weight"],
      i = theme.utils.extractWeightAndUnit(t.title)["weight"];
    let r = 0,
      a = (0 < s && (r = Number((e.price / s).toFixed(2))), 0),
      n = (0 < i && (a = Number((t.price / i).toFixed(2))), 0);
    return 0 < r && 0 < a && ((e = r - a), (n = Math.round((e / r) * 100))), n;
  }
  _updateDiscountAmount(e, t = null) {
    this?.discountPercentageWrapper &&
      this?.discountPercentage &&
      ((t = this.subscriptionTypeInputs?.subscription?.checked ? 15 : (t ?? this.getDiscountPercentage(this.productData.variants[0], e)))
        ? (this.discountPercentageWrapper.classList.remove("hidden"), (this.discountPercentage.innerHTML = t + "%"))
        : this.discountPercentageWrapper.classList.add("hidden"));
  }
  _updatePrice(e) {
    var a = this.subscriptionTypeInputs.subscription.checked,
      n = {
        subscription: {
          price: this.querySelectorAll("[js-subscription-current-price]"),
          comparePrice: this.querySelectorAll("[js-subscription-compare-price]"),
        },
        total: { price: this.querySelectorAll("[js-total-price]"), compare: this.querySelectorAll("[js-total-compare]") },
      },
      o = e["selling_plan_allocations"];
    const t = new FormData(this.form).get("selling_plan");
    if (t) {
      o = o.find((e) => e?.selling_plan_id == t);
      if (o.price && o.compare_at_price) {
        const t = o.price,
          s = o.compare_at_price,
          i = a ? t : e.price,
          r = a ? e.price : e.compare_at_price;
        this.price.current.forEach((e) => {
          e.innerHTML = theme.utils.formatMoney(i);
        }),
          this.price.compare.forEach((e) => {
            r ? ((e.innerHTML = theme.utils.formatMoney(r)), e.classList.remove("hidden")) : e.classList.add("hidden");
          }),
          n.subscription.price.forEach((e) => {
            e.innerHTML = theme.utils.formatMoney(t);
          }),
          n.subscription.comparePrice.forEach((e) => {
            e.innerHTML = theme.utils.formatMoney(s);
          });
      }
    }
  }
  _disableButtons() {
    this.buttons.forEach((e) => {
      e.setAttribute("disabled", "");
      e = e.querySelector(this._selectors.loader);
      e && e.setAttribute("loading", "");
    });
  }
  _enableButtons() {
    this.buttons.forEach((e) => {
      e.removeAttribute("disabled");
      e = e.querySelector(this._selectors.loader);
      e && e.removeAttribute("loading");
    });
  }
  _handleAnchorClick(e) {
    e.preventDefault();
    (e = e.currentTarget.getAttribute("href")), (e = document.querySelector(e));
    e &&
      (e.scrollIntoView({ behavior: "smooth", block: "start" }), e.classList.contains("accordion-header")) &&
      "false" === e.getAttribute("aria-expanded") &&
      e.click();
  }
  _getSelectedVariant() {
    let e;
    return (
      !!(e = this.variantInputs
        ? Array.from(this.variantInputs)
            .find((e) => e.checked)
            .closest("[js-option-item]")
            ?.getAttribute("data-variant-id")
        : this.querySelector("[js-master-variant-select]")?.value) && this._getVariantById(e)
    );
  }
  _getVariantById(t) {
    return this.productData.variants.find((e) => e.id == t) ?? !1;
  }
  _handleFunnelRedirect(o) {
    if (((this.isCookieValid = o && o?.chosenProduct?.shopifyProductId === this.productData.id), this.isCookieValid)) {
      const {
        deliveryFrequencyInWeeks: e,
        adultStarterKit: t,
        puppyStarterKit: s,
        foodGramsPerDay: i,
        kilogramsPerDelivery: r,
        shopifyProductVariantId: a,
        pickinessGuidance: n,
      } = (this.cookieData = o).chosenProduct;
      this._handleDogDetails(e, r, i, o.dog);
      var o = this.querySelector("[js-schedule-picker]"),
        c = this._getSellingPlanGroupId(e),
        o = ((o.value = c), Array.from(this.variantOptions).find((e) => e.getAttribute("data-variant-id") == a)),
        o =
          (o && (o.querySelector("input").click(), (c = this._getVariantById(a)), this._handleVariantChange({ detail: { variant: c, priceChange: !0 } })),
          this.querySelectorAll(this._selectors.cookieOnlyItem));
      o && o.forEach((e) => e.classList.remove("hidden")), (t || s) && this._handleStarterKitSelection(t, s), n && this.additionalItems.push(49019415331143);
    }
  }
  _handleDogDetails(e, t, s, i) {
    var r,
      a = {
        container: this.querySelector(this._selectors.dog.container),
        name: this.querySelector(this._selectors.dog.name),
        breed: this.querySelector(this._selectors.dog.breed),
        recommendations: {
          grams: document.querySelectorAll(this._selectors.dog.recommendations.grams),
          weight: this.querySelector(this._selectors.dog.recommendations.weight),
          schedule: this.querySelector(this._selectors.dog.recommendations.schedule),
        },
      };
    a.container &&
      (a.container.classList.remove("hidden"),
      (r = i?.pureBreed || i?.breeds?.join(" / ") || null) ? (a.breed.innerHTML = r) : a.breed.classList.add("hidden"),
      i?.name ? (a.name.innerHTML = i.name) : a.name.classList.add("hidden"),
      a.recommendations.grams.forEach((e) => (e.innerHTML = Math.trunc(s) + " g")),
      (a.recommendations.weight.innerHTML = t + " kg"),
      (a.recommendations.schedule.innerHTML = e));
  }
  _handleStarterKitSelection(e, t) {
    (e || t) && document.dispatchEvent(new CustomEvent("startkit:select", { detail: { selectedType: e ? "adult" : "puppy" } }));
  }
  _getSellingPlanGroupId(e) {
    const t = e + " Week(s)";
    e = this.productData.selling_plan_groups[0].selling_plans.find((e) => e.options.some((e) => e.value === t));
    return e ? e.id : null;
  }
}

class MediaVideo extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        video: "[js-video]",
        unmuteButton: "[js-video-unmute-button]",
        muteButton: "[js-video-mute-button]",
        unmuteWrapper: "[js-video-unmute]",
        muteWrapper: "[js-video-mute]",
      }),
      (this._unmuteVideo = this._unmuteVideo.bind(this)),
      (this._muteVideo = this._muteVideo.bind(this)),
      (this._handleResize = this._handleResize.bind(this));
  }
  connectedCallback() {
    (this.videos = this.querySelectorAll(this._selectors.video)),
      (this.unmuteButton = this.querySelector(this._selectors.unmuteButton)),
      (this.muteButton = this.querySelector(this._selectors.muteButton)),
      (this.unmuteWrapper = this.querySelector(this._selectors.unmuteWrapper)),
      (this.muteWrapper = this.querySelector(this._selectors.muteWrapper)),
      this._watchWindowResize(),
      this._initListeners();
  }
  _initListeners() {
    this.unmuteButton.addEventListener("click", this._unmuteVideo),
      this.muteButton.addEventListener("click", this._muteVideo),
      document.addEventListener("media-video-mute", this._muteVideo);
  }
  _getVisibleVideo() {
    var e = this.querySelector(".media-video__video-container--mobile"),
      t = this.querySelector(".media-video__video-container--desktop");
    return e && "none" !== window.getComputedStyle(e).display
      ? e.querySelector(this._selectors.video)
      : t && "none" !== window.getComputedStyle(t).display
        ? t.querySelector(this._selectors.video)
        : null;
  }
  _unmuteVideo() {
    var e = this._getVisibleVideo();
    e && ((e.muted = !1), e.play()), this._updateUIForUnmute();
  }
  _muteVideo() {
    var e = this._getVisibleVideo();
    e && (e.muted = !0), this._updateUIForMute();
  }
  _updateUIForMute() {
    this.muteWrapper.classList.add("opacity-0", "pointer-events-none"),
      this.muteWrapper.classList.remove("opacity-100"),
      this.unmuteWrapper.classList.add("opacity-100"),
      this.unmuteWrapper.classList.remove("opacity-0", "pointer-events-none");
  }
  _updateUIForUnmute() {
    this.unmuteWrapper.classList.add("opacity-0", "pointer-events-none"),
      this.unmuteWrapper.classList.remove("opacity-100"),
      this.muteWrapper.classList.add("opacity-100"),
      this.muteWrapper.classList.remove("opacity-0", "pointer-events-none");
  }
  _watchWindowResize = (e) => {
    window.addEventListener("resize", this._handleResize);
  };
  _handleResize() {
    var e = this._getVisibleVideo();
    e && !e.muted && ((e.muted = !0), this._updateUIForMute());
  }
}
class Media extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        video: "[js-video]",
        unmuteButton: "[js-video-unmute-button]",
        muteButton: "[js-video-mute-button]",
        unmuteWrapper: "[js-video-unmute]",
        muteWrapper: "[js-video-mute]",
        swiperCarousel: "[js-media-carousel]",
      }),
      (this._onSlideChange = this._onSlideChange.bind(this));
  }
  connectedCallback() {
    (this.videos = this.querySelectorAll(this._selectors.video)),
      (this.swiperCarousel = this.querySelector(this._selectors.swiperCarousel)),
      this._attachSwiperEvents();
  }
  _attachSwiperEvents() {
    this.swiperCarousel && this.swiperCarousel.swiper
      ? ((this.swiper = this.swiperCarousel.swiper), this.swiper.on("slideChange", this._onSlideChange))
      : console.error("Swiper instance not found on swiperCarousel");
  }
  _onSlideChange() {
    this.videos.forEach((e) => {
      e.muted = !0;
    });
    var e = new CustomEvent("media-video-mute");
    document.dispatchEvent(e);
  }
}
class Blog extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        loadMoreButton: "[js-load-more]",
        articlesContainer: "[js-articles-container]",
        currentCount: "[js-current-count]",
        totalCount: "[js-total-count]",
        allLoadMoreButton: "#all-load-more",
        allArticlesContainer: "#articles-container",
        articleCard: ".all-blogs-article",
        allCurrentCount: "#all-current-count",
        allTotalCount: "#all-total-count",
      });
  }
  connectedCallback() {
    var e, t;
    (this.loadMoreButton = this.querySelector(this._selectors.loadMoreButton)),
      (this.articlesContainer = this.querySelector(this._selectors.articlesContainer)),
      (this.currentCountElement = this.querySelector(this._selectors.currentCount)),
      (this.totalCountElement = this.querySelector(this._selectors.totalCount)),
      (this.allLoadMoreButton = document.querySelector(this._selectors.allLoadMoreButton)),
      (this.allArticlesContainer = document.querySelector(this._selectors.allArticlesContainer)),
      (this.allCurrentCountElement = document.querySelector(this._selectors.allCurrentCount)),
      (this.allTotalCountElement = document.querySelector(this._selectors.allTotalCount)),
      (this.loadMoreButton = this.querySelector(this._selectors.loadMoreButton)),
      this.loadMoreButton &&
        ((e =
          (parseInt(this.loadMoreButton.getAttribute("data-current-count"), 10) / parseInt(this.loadMoreButton.getAttribute("data-total-count"), 10)) * 100),
        (t = this.querySelector("[js-progress-bar]")) && (t.style.width = e + "%"),
        this.loadMoreButton.addEventListener("click", this._onLoadMore.bind(this))),
      this.allLoadMoreButton &&
        (this.allLoadMoreButton.addEventListener("click", this._onAllLoadMore.bind(this)), this._updateAllArticleCounts(), this._updateAllProgressBar());
  }
  _onLoadMore() {
    var e = this.loadMoreButton.getAttribute("data-url");
    e &&
      fetch(e)
        .then((e) => e.text())
        .then((e) => {
          var e = new DOMParser().parseFromString(e, "text/html"),
            t = e.querySelectorAll(this._selectors.articlesContainer + " > li"),
            e = e.querySelector(this._selectors.loadMoreButton),
            s =
              (t.forEach((e) => {
                this.articlesContainer.appendChild(e.cloneNode(!0));
              }),
              parseInt(this.loadMoreButton.getAttribute("data-current-count"), 10)),
            i = parseInt(this.loadMoreButton.getAttribute("data-total-count"), 10),
            t = ((s += t.length), this.loadMoreButton.setAttribute("data-current-count", s), this.querySelector("[js-current-count]")),
            r = this.querySelector("[js-total-count]"),
            t = (t && r && ((t.textContent = s), (r.textContent = i)), this.querySelector("[js-progress-bar]"));
          t && (t.style.width = (s / i) * 100 + "%"),
            e
              ? ((r = e.getAttribute("data-url")),
                (t = e.getAttribute("data-current-count")),
                this.loadMoreButton.setAttribute("data-url", r),
                this.loadMoreButton.setAttribute("data-current-count", t))
              : (this.loadMoreButton.style.display = "none");
        })
        .catch((e) => console.error("Error:", e));
  }
  _updateAllProgressBar() {
    var e = this.allArticlesContainer.querySelectorAll(this._selectors.articleCard).length,
      e = (this.allArticlesContainer.querySelectorAll(this._selectors.articleCard + ":not(.hidden)").length / e) * 100,
      t = document.getElementById("all-progress-bar");
    t && (t.style.width = e + "%");
  }
  _onAllLoadMore() {
    var e = this.allArticlesContainer.querySelectorAll(this._selectors.articleCard + ".hidden");
    let s = 0;
    e.forEach((e, t) => {
      t < 8 && (e.classList.remove("hidden"), s++);
    }),
      this._updateAllArticleCounts(),
      this._updateAllProgressBar(),
      e.length - s == 0 && (this.allLoadMoreButton.style.display = "none");
  }
  _updateAllArticleCounts() {
    var e = this.allArticlesContainer.querySelectorAll(this._selectors.articleCard).length,
      t = this.allArticlesContainer.querySelectorAll(this._selectors.articleCard + ":not(.hidden)").length;
    this.allCurrentCountElement && (this.allCurrentCountElement.textContent = t), this.allTotalCountElement && (this.allTotalCountElement.textContent = e);
  }
}
customElements.define("s-collection-grid", CollectionGrid),
  customElements.define("s-blog", Blog),
  customElements.define("s-product", ProductMain),
  customElements.define("bundle-product", ProductBundle),
  // customElements.define("product-recommendations", ProductRecommendations),
  customElements.define("s-video", MediaVideo),
  customElements.define("s-media", Media);
class Account extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        addressCountrySelect: "[js-country-select]",
        editAddressModal: "[js-edit-address-modal]",
        editAddressOpen: "[js-edit-address]",
        editAddressForm: "[js-edit-address-form]",
        deleteAddressButton: "[js-delete-address]",
        ordersContainer: "[js-orders]",
        ordersPagination: "[js-next-page]",
        order: "[js-order]",
      });
  }
  connectedCallback() {
    (this.countrySelects = this.querySelectorAll(this._selectors.addressCountrySelect)),
      (this.editAddressModal = this.querySelector(this._selectors.editAddressModal)),
      (this.openEditAddress = this.querySelectorAll(this._selectors.editAddressOpen)),
      (this.editAddressForms = this.querySelectorAll(this._selectors.editAddressForm)),
      (this.deleteAddressButtons = this.querySelectorAll(this._selectors.deleteAddressButton)),
      (this.ordersContainer = this.querySelector(this._selectors.ordersContainer)),
      (this.ordersPagination = this.querySelector(this._selectors.ordersPagination)),
      this._setupCountries(),
      this._setupEventListeners();
  }
  _setupCountries() {
    Shopify &&
      Shopify.CountryProvinceSelector &&
      (new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", { hideElement: "AddressProvinceContainerNew" }),
      this.countrySelects.forEach((e) => {
        e = e.dataset.formId;
        new Shopify.CountryProvinceSelector("AddressCountry_" + e, "AddressProvince_" + e, { hideElement: "AddressProvinceContainer_" + e });
      }));
  }
  _setupEventListeners() {
    this.ordersPagination && this.ordersPagination.addEventListener("click", this._addOrders),
      this.openEditAddress.forEach((e) => {
        e.addEventListener("click", this._handleOpenEditAddress);
      }),
      this.deleteAddressButtons.forEach((e) => {
        e.addEventListener("click", this._handleDeleteAddress);
      }),
      this.editAddressModal.addEventListener("close", this._handleCloseEditAddress);
  }
  _addOrders = async () => {
    var e = this.ordersPagination.dataset.url,
      e = await this._getOrders(e),
      t = e.querySelector(this._selectors.ordersContainer).innerHTML,
      e = e.querySelector(this._selectors.ordersPagination);
    this.ordersContainer.insertAdjacentHTML("beforeend", t),
      e ? (this.ordersPagination.dataset.url = e.dataset.url) : this.ordersPagination.remove(),
      this.ordersContainer.connectedCallback();
  };
  _getOrders(e) {
    return fetch(e)
      .then((e) => e.text())
      .then((e) => {
        return new DOMParser().parseFromString(e, "text/html");
      });
  }
  _handleOpenEditAddress = (e) => {
    e.stopPropagation();
    (e = e.currentTarget.dataset.form), (e = document.querySelector("#address_form_" + e));
    e.classList.remove("hidden"), this.editAddressModal.open(), e.querySelector('[name="address[first_name]"]').focus();
  };
  _handleDeleteAddress = (e) => {
    e = e.currentTarget.dataset.target;
    confirm("Are you sure you want to delete this address?") && Shopify.postLink(e, { parameters: { _method: "delete" } });
  };
  _handleCloseEditAddress = (e) => {
    this.editAddressForms.forEach((e) => {
      e.classList.add("hidden");
    });
  };
}
class AccountLogin extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = {
        view: { activation: "[js-activation-view]", recovery: "[js-recovery-view]", main: "[js-main-view]" },
        toggle: { activation: "[js-toggle-activation]", recovery: "[js-toggle-recovery]", main: "[js-toggle-main]" },
        activation: { form: "[js-activation-form]", message: "[js-activation-message]" },
      }),
      (this.views = {}),
      (this.toggles = {});
  }
  connectedCallback() {
    this._initializeElements(), this._attachEventListeners();
  }
  _initializeElements() {
    Object.keys(this._selectors.view).forEach((e) => {
      this.views[e] = this.querySelector(this._selectors.view[e]);
    }),
      Object.keys(this._selectors.toggle).forEach((e) => {
        this.toggles[e] = this.querySelectorAll(this._selectors.toggle[e]);
      }),
      (this.activationForm = this.querySelector(this._selectors.activation.form));
  }
  _attachEventListeners() {
    Object.keys(this.toggles).forEach((t) => {
      this.toggles[t].forEach((e) => {
        e.addEventListener("click", () => this._toggleView(t));
      });
    }),
      this.activationForm.addEventListener("submit", this._activationSubmitHandler.bind(this));
  }
  _toggleView(t) {
    Object.keys(this.views).forEach((e) => {
      this.views[e].classList.toggle("hidden", e !== t);
    });
  }
  _activationSubmitHandler(e) {
    e.preventDefault();
    const t = this.activationForm.querySelector("input").value,
      s = new XMLHttpRequest();
    s.open("POST", "https://api.vuffeli.dk/Customer/ResendActivationLink"),
      s.setRequestHeader("Content-Type", " application/json"),
      s.send(`"${t}"`),
      (s.onreadystatechange = () => {
        s.readyState === XMLHttpRequest.DONE &&
          (e.target.querySelector(".js-activation-message").classList.add("hidden"),
          (e.target.querySelector(".resend-activation-message").textContent = "Vi har sendt en aktiveringsmail til " + t),
          e.target.querySelector(".resend-activation-message").classList.remove("hidden"));
      });
  }
}
class Search extends HTMLElement {
  constructor() {
    super(),
      (this._selectors = { results: "[js-search-results]", next: "[js-search-next]" }),
      (this.results = this.querySelector(this._selectors.results)),
      (this.nextBtn = this.querySelector(this._selectors.next)),
      (this._handleLoadMore = this._handleLoadMore.bind(this));
  }
  connectedCallback() {
    this.nextBtn && this.nextBtn.addEventListener("click", this._handleLoadMore);
  }
  async _handleLoadMore(e) {
    e.preventDefault();
    (e = this.nextBtn.getAttribute("href")),
      (e = await fetch(e)
        .then((e) => e.text())
        .then((e) => {
          e = new DOMParser().parseFromString(e, "text/html");
          return { results: e.querySelectorAll(this._selectors.results + " li"), nextPage: e.querySelector(this._selectors.next)?.getAttribute("href") ?? !1 };
        })
        .catch((e) => console.error(e)));
    e.nextPage ? this.nextBtn.setAttribute("href", e.nextPage) : this.nextBtn.remove(), e.results && e.results.forEach((e) => this.results.appendChild(e));
  }
}
customElements.define("s-account", Account), customElements.define("s-login", AccountLogin), customElements.define("search-template", Search);
